/* Presentation-only receipt: called exclusively by confirmed native cart commits. */
(() => {
 if(window.MonsterCommerceMotion) return;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const visible=node=>{if(!node?.isConnected)return false;const r=node.getBoundingClientRect();return r.width>0&&r.height>0&&r.bottom>0&&r.top<innerHeight&&r.right>0&&r.left<innerWidth&&getComputedStyle(node).visibility!=='hidden';};
 const pulse=node=>{
  if(!visible(node)||!node.animate)return;
  node.animate([{opacity:1},{opacity:.65},{opacity:1}],{duration:reduced.matches?240:360}).finished.catch(()=>{});
 };
 const flight=({button,images=[]})=>{
  if(reduced.matches){pulse(button);return;}
  const cart=[...document.querySelectorAll('a[aria-controls="CartDrawer"],a[href$="/cart"]')].find(node=>node.querySelector('svg')&&visible(node));
  const anyCart=cart||document.querySelector('a[aria-controls="CartDrawer"]');
  if(!anyCart?.querySelector('svg')){pulse(button);return;}
  const layer=document.createElement('div');layer.className='mk-cart-flight-layer';layer.setAttribute('aria-hidden','true');layer.setAttribute('popover','manual');document.body.append(layer);
  try{layer.showPopover?.();}catch{}
  let target=cart;
  // A modal or an offscreen header needs a visible copy of the real cart icon.
  if(!cart||document.querySelector('dialog[open]')){
   target=document.createElement('span');target.className='mk-cart-receipt-anchor';target.append(anyCart.querySelector('svg').cloneNode(true));layer.append(target);
  }
  const destination=target.getBoundingClientRect();
  const sources=images.filter(Boolean).slice(0,3);
  if(!sources.length){layer.remove();pulse(button);return;}
  const promote=()=>{
   if(!layer.isConnected)return;
   if(!layer.querySelector('.mk-cart-receipt-anchor')){
    const anchor=document.createElement('span');anchor.className='mk-cart-receipt-anchor';anchor.style.left=destination.left+'px';anchor.style.top=destination.top+'px';anchor.style.right='auto';anchor.append(anyCart.querySelector('svg').cloneNode(true));layer.append(anchor);
   }
   try{layer.hidePopover?.();layer.showPopover?.();}catch{}
  };
  document.addEventListener('dialog:open',promote);
  const clean=()=>{document.removeEventListener('dialog:open',promote);try{layer.hidePopover?.();}catch{}layer.remove();};
  const animations=[];
  try{
   sources.forEach((source,index)=>{
    const img=document.createElement('img');img.className='mk-cart-flight';img.alt='';img.src=source.currentSrc||source.src||source;img.setAttribute('aria-hidden','true');
    const r=visible(source)?source.getBoundingClientRect():visible(button)?button.getBoundingClientRect():{left:innerWidth/2-32,top:innerHeight-112,width:64,height:64};
    const x=Math.max(8,Math.min(innerWidth-72,r.left+r.width/2-32)),y=Math.max(8,Math.min(innerHeight-72,r.top+r.height/2-32));
    img.style.left=x+'px';img.style.top=y+'px';layer.append(img);
    const dx=destination.left+destination.width/2-x-32,dy=destination.top+destination.height/2-y-32;
    const animation=img.animate([{transform:'translate(0,0) scale(1)',opacity:.96},{transform:`translate(${dx*.45}px,${dy*.35-48}px) scale(.8)`,opacity:.92,offset:.48},{transform:`translate(${dx}px,${dy}px) scale(.12)`,opacity:0}],{duration:680,delay:index*90,easing:'cubic-bezier(.22,.61,.36,1)',fill:'both'});
    animation.id='mk-cart-flight-'+index;animations.push(animation.finished.catch(()=>{}));
   });
   Promise.all(animations).then(()=>{pulse(cart||button);clean();});
   setTimeout(clean,1400);
  }catch{clean();pulse(button);}
 };
 window.MonsterCommerceMotion={commit(detail){requestAnimationFrame(()=>{try{flight(detail);}catch{}});}};
 // CartAddEvent is emitted only by the native KallesProductForm success branch.
 // Capture before its existing drawer listener; never submit or fetch from here.
 document.addEventListener('cart:update',event=>{
  const detail=event.detail,host=event.target.closest?.('wrapp-hdt-pr-frm,hdt-product-form,hdt-product-form-bundle');
  if(!host||detail?.source!=='product-form-component'||detail.data?.didError||detail.cartData?.status||!detail.cartData?.id)return;
  const button=host.querySelector('form [name="add"]');
  const root=host.closest('[data-monster-product]')||host.closest('.mk-cart-setup__card')||host;
  const image=root.querySelector('.hdt-product-media__main .is-selected img,.hdt-product-media__main img,[data-studio-main-image],img');
  window.MonsterCommerceMotion.commit({button,images:[image]});
 },true);
})();

(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const initialize = (scope = document) => scope.querySelectorAll('[data-footer-top]').forEach(link => {
  if (link.dataset.footerReady) return;
  link.dataset.footerReady = 'true';
  link.addEventListener('click', event => {
   event.preventDefault();
   window.scrollTo({top: 0, behavior: reduced.matches ? 'instant' : 'smooth'});
  });
 });
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
 else initialize();
 document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

(() => {
 function preparePolicy(){
  const body=document.querySelector('.hdt-page-type-policy .shopify-policy__body');
  if(!body)return;
  document.documentElement.classList.add('mk-policy-scroll');
  if(body.querySelector('.mk-policy-index'))return;
  const headings=[...body.querySelectorAll('h2')];
  if(headings.length<2)return;
  const index=document.createElement('section');index.className='mk-policy-index';index.setAttribute('aria-label','On this page');
  const header=document.createElement('div');header.className='mk-policy-index-heading';
  const title=document.createElement('strong');title.textContent='On this page';
  const hint=document.createElement('span');hint.textContent='Quick links';
  header.append(title,hint);
  const nav=document.createElement('nav');nav.setAttribute('aria-label','Policy sections');
  headings.forEach((heading,i)=>{
   if(!heading.id)heading.id='mk-policy-section-'+(i+1);
   const link=document.createElement('a');link.href='#'+heading.id;
   const label=heading.textContent.trim();
   link.textContent=label===label.toUpperCase()?label.charAt(0)+label.slice(1).toLowerCase():label;
   nav.append(link);
  });
  index.append(header,nav);body.prepend(index);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',preparePolicy,{once:true});else preparePolicy();
})();

(() => {
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const openings=new Map();
 const syncGutter=()=>document.documentElement.classList.toggle('kalles-has-opening',openings.size>0);
 function initialize(scope=document){
  scope.querySelectorAll('[data-kalles-video]').forEach(host=>{
   if(host.dataset.initialized)return;host.dataset.initialized='true';
   const video=host.querySelector('video');
   const mobile=matchMedia('(max-width: 767px)');
   let visible=false;
   const update=()=>{
    if(reduced.matches||document.hidden||!visible){video.pause();return;}
    const source=mobile.matches?video.dataset.mobileSrc:video.dataset.desktopSrc;
    if(video.getAttribute('src')!==source){host.classList.remove('is-ready');video.src=source;video.load();}
    video.play().catch(()=>{});
   };
   video.addEventListener('playing',()=>host.classList.add('is-ready'));
   video.addEventListener('error',()=>host.classList.remove('is-ready'));
   new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;update();},{threshold:.5}).observe(host);
   mobile.addEventListener('change',update);reduced.addEventListener('change',update);document.addEventListener('visibilitychange',update);
  });
  scope.querySelectorAll('[data-kalles-opening]').forEach(opening=>{
   if(openings.has(opening))return;
   const video=opening.querySelector('video'),trigger=opening.parentElement.querySelector('[data-opening-trigger]');
   if(!video?.dataset.openingSrc||!trigger||!opening.showModal)return;
   const listeners=new AbortController();
   const listen=(node,type,handler)=>node.addEventListener(type,handler,{signal:listeners.signal});
   let active=false,generation=0,deadline;
   const finish=(restoreFocus=true)=>{
    if(!active&&!opening.open)return;
    active=false;generation++;clearTimeout(deadline);
    if(opening.open)opening.close();
    opening.hidden=true;video.pause();video.removeAttribute('src');video.load();
    if(restoreFocus&&trigger.isConnected&&!document.hidden)trigger.focus({preventScroll:true});
   };
   const armDeadline=()=>{clearTimeout(deadline);if(active)deadline=setTimeout(()=>finish(),15000);};
   const destroy=()=>{
    finish(false);listeners.abort();trigger.hidden=true;delete opening.dataset.initialized;
    openings.delete(opening);syncGutter();
   };
   openings.set(opening,{finish,destroy});syncGutter();
   opening.dataset.initialized='true';trigger.hidden=false;
   listen(trigger,'click',()=>{
    if(active||opening.open||document.hidden)return;
    active=true;const turn=++generation;opening.hidden=false;
    try{
     opening.showModal();video.src=video.dataset.openingSrc;video.load();
     if(!reduced.matches){
      armDeadline();
      video.play().then(()=>{if(!active)video.pause();},()=>{if(active&&turn===generation)finish();});
     }
    }catch{finish();}
   });
   listen(opening.querySelector('[data-opening-skip]'),'click',()=>finish());
   listen(opening,'cancel',event=>{event.preventDefault();finish();});
   listen(opening,'close',()=>{if(!opening.open)finish();});
   listen(video,'ended',()=>finish());listen(video,'error',()=>finish());
   listen(video,'playing',()=>clearTimeout(deadline));
   listen(video,'waiting',armDeadline);listen(video,'stalled',armDeadline);
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
 document.addEventListener('shopify:section:unload',event=>{
  openings.forEach((state,opening)=>{if(event.target.contains(opening))state.destroy();});
 });
 document.addEventListener('visibilitychange',()=>{if(document.hidden)openings.forEach(state=>state.finish(false));});
 reduced.addEventListener('change',()=>{if(reduced.matches)openings.forEach(state=>state.finish());});
 window.addEventListener('pagehide',()=>openings.forEach(state=>state.finish(false)));
})();

// Draft option examples stay in the preview; actual catalog variants use the native picker.
(() => {
 const states=new Map();
 const allPeers=key=>[...document.querySelectorAll('[data-mk-preview-options]')].filter(peer=>peer.dataset.previewProduct===key);
 const closeDropdown=dropdown=>{
  if(!dropdown)return;
  const panel=dropdown.querySelector('.mk-color-panel');
  if(panel?.matches(':popover-open'))panel.hidePopover();
  dropdown.open=false;
  dropdown.querySelector('summary').setAttribute('aria-expanded','false');
 };
 const sync=key=>{
  const state=states.get(key);if(!state)return;
  allPeers(key).forEach(peer=>{
   peer.querySelectorAll('[data-preview-select-option]').forEach(s=>s.value=state[s.dataset.previewSelectOption]);
   peer.querySelectorAll('[data-preview-choice]').forEach(button=>button.setAttribute('aria-selected',String(state[button.dataset.optionKey]===button.dataset.optionValue)));
   peer.querySelectorAll('[data-option-key][data-color-dropdown]').forEach(dropdown=>{
    const value=state[dropdown.dataset.optionKey],summary=dropdown.querySelector('summary');
    summary.querySelector('[data-selected-option-name]').textContent=value;
    summary.setAttribute('aria-label',summary.dataset.optionLabel+': '+value);
   });
   const colors=[...peer.querySelectorAll('[data-preview-color]')];
   colors.forEach(button=>{
    const selected=button.dataset.color===state.color;
    button.setAttribute('aria-pressed',String(selected));button.setAttribute('aria-selected',String(selected));
   });
   const selected=colors.find(button=>button.dataset.color===state.color),summary=peer.querySelector('[data-color-dropdown]>summary');
   if(selected&&summary){
    summary.querySelector('[data-selected-color-name]').textContent=state.color;
    summary.setAttribute('aria-label',summary.dataset.colorLabel+': '+state.color);
    const dot=summary.querySelector('[data-selected-color-dot]'),source=selected.querySelector('.mk-color-dot');
    dot.style.setProperty('--mk-swatch-color',selected.style.getPropertyValue('--mk-swatch-color'));
    dot.replaceChildren(...[...source.childNodes].map(node=>node.cloneNode(true)));
   }
   if((state.kit||state['key-quantity'])&&peer.dataset.placement==='main'){
    const root=peer.closest('[data-monster-product]'),units=(state['key-quantity']||state.kit).replace('PCS','');
    root?.querySelectorAll('.mk-product-included>span').forEach(e=>e.textContent=units+'-key kit');
    const count=root?.querySelector('.mk-demo-kit-guide dd');if(count)count.textContent=units;
    const intro=root?.querySelector('.mk-demo-kit-guide>div>p');if(intro)intro.textContent=intro.textContent.replace(/\b(129|149)\b/,units);
   }
  });
  document.dispatchEvent(new CustomEvent('mk:preview:change',{detail:{productId:key,values:{...state}}}));
 };
 document.addEventListener('mk:preview:set',event=>{
  const {productId,key,value}=event.detail||{},source=allPeers(productId)[0];if(!source||!states.has(productId))return;
  const allowed=key==='color'?[...source.querySelectorAll('[data-preview-color]')].map(b=>b.dataset.color):[...source.querySelectorAll('[data-preview-choice]')].filter(b=>b.dataset.optionKey===key).map(b=>b.dataset.optionValue);
  if(allowed.includes(value)){states.get(productId)[key]=value;sync(productId);}
 });
 const placePanel=dropdown=>{
  const panel=dropdown.querySelector('.mk-color-panel'),summary=dropdown.querySelector('summary'),rect=summary.getBoundingClientRect();
  const width=Math.min(Math.max(rect.width,dropdown.dataset.optionKey?144:176),innerWidth-24),gap=5;
  const desiredHeight=dropdown.querySelectorAll('[role=option]').length*44+10;
  const scale=rect.width/summary.offsetWidth||1;
  panel.style.zoom=String(1/scale);
  const below=innerHeight-rect.bottom-12,above=rect.top-12;
  const preferAbove=dropdown.closest('[data-placement="sticky"]')||below<desiredHeight&&above>below;
  const available=Math.max(80,preferAbove?above:below),height=Math.min(desiredHeight,available);
  panel.style.width=width+'px';panel.style.maxHeight=height+'px';
  panel.style.left=Math.min(Math.max(12,rect.left),innerWidth-width-12)+'px';
  panel.style.top=(preferAbove?rect.top-gap-height:rect.bottom+gap)+'px';
  panel.style.bottom='auto';
  if(panel.showPopover&&!panel.matches(':popover-open'))panel.showPopover();
 };
 const initialize=(scope=document)=>{
  scope.querySelectorAll('[data-mk-preview-options]').forEach(peer=>{
   if(peer.dataset.ready)return;peer.dataset.ready='true';
   const key=peer.dataset.previewProduct;
   if(!states.has(key)){
    const state={color:peer.querySelector('[data-preview-color]')?.dataset.color||''};
    peer.querySelectorAll('[data-preview-select-option]').forEach(select=>state[select.dataset.previewSelectOption]=select.value);
    peer.querySelectorAll('[data-preview-choice]').forEach(button=>{if(!(button.dataset.optionKey in state))state[button.dataset.optionKey]=button.dataset.optionValue;});
    states.set(key,state);
   }
   peer.querySelectorAll('[data-color-dropdown]').forEach(dropdown=>dropdown.addEventListener('toggle',()=>{
    if(!dropdown.open){closeDropdown(dropdown);return;}
    document.querySelectorAll('[data-color-dropdown][open]').forEach(other=>{if(other!==dropdown)closeDropdown(other);});
    dropdown.querySelector('summary').setAttribute('aria-expanded','true');placePanel(dropdown);
   }));
   if(peer.dataset.placement==='main'){
    const root=peer.closest('[data-monster-product]'),form=document.getElementById(peer.dataset.mainForm);
    const stop=event=>{event.preventDefault();event.stopImmediatePropagation();const note=root?.querySelector('[data-option-preview-note]');if(note)note.hidden=false;};
    root?.addEventListener('click',event=>{if(event.target.closest('button[name="add"],[data-bundle-add],[data-sticky-bundle-add]'))stop(event);},true);
    form?.addEventListener('submit',stop,true);
   }
   sync(key);
  });
  scope.querySelectorAll('[data-sticky-native-options]').forEach(options=>{
   if(options.dataset.ready)return;
   const form=document.getElementById(options.dataset.mainForm),picker=[...document.querySelectorAll('hdt-variant-picker')].find(e=>e.getAttribute('form')===options.dataset.mainForm);
   if(!form||!picker)return;options.dataset.ready='true';
   const sync=()=>options.querySelectorAll('[data-sticky-native-option]').forEach(select=>{
    const field=picker.querySelector('fieldset[data-index="'+select.dataset.optionIndex+'"]');if(!field)return;
    const current=field.querySelector('input[is-value][type=hidden],input[is-value]:checked');if(current)select.value=current.value;
    select.disabled=picker.classList.contains('loading');
    [...select.options].forEach(option=>{
     const source=[...field.querySelectorAll('[role=option]')].find(e=>e.getAttribute('value')===option.value);
     option.disabled=Boolean(source&&(source.disabled||source.classList.contains('is-unavailable')));
     option.textContent=option.value+(source?.classList.contains('is-disabled')?' — '+options.dataset.soldOut:'');
    });
   });
   options.addEventListener('change',event=>{
    const select=event.target.closest('[data-sticky-native-option]');if(!select)return;
    const field=picker.querySelector('fieldset[data-index="'+select.dataset.optionIndex+'"]'),input=field?.querySelector('input[is-value][type=hidden]');
    if(!input)return;input.value=select.value;input.dispatchEvent(new Event('change',{bubbles:true}));
   });
   form.addEventListener('variant:change',sync);picker.addEventListener('change',sync);
   new MutationObserver(sync).observe(picker,{subtree:true,childList:true,attributes:true,attributeFilter:['class','aria-selected','disabled']});sync();
  });

 };
 document.addEventListener('change',event=>{
  const select=event.target.closest('[data-preview-select-option]'),peer=select?.closest('[data-mk-preview-options]');
  if(!peer)return;states.get(peer.dataset.previewProduct)[select.dataset.previewSelectOption]=select.value;sync(peer.dataset.previewProduct);
 });
 document.addEventListener('click',event=>{
  const button=event.target.closest('[data-preview-color]'),peer=button?.closest('[data-mk-preview-options]');
  if(peer){states.get(peer.dataset.previewProduct).color=button.dataset.color;sync(peer.dataset.previewProduct);const dropdown=button.closest('[data-color-dropdown]');closeDropdown(dropdown);dropdown.querySelector('summary').focus({preventScroll:true});}
  const choice=event.target.closest('[data-preview-choice]'),choicePeer=choice?.closest('[data-mk-preview-options]');
  if(choicePeer){states.get(choicePeer.dataset.previewProduct)[choice.dataset.optionKey]=choice.dataset.optionValue;sync(choicePeer.dataset.previewProduct);const dropdown=choice.closest('[data-color-dropdown]');closeDropdown(dropdown);dropdown.querySelector('summary').focus({preventScroll:true});}
  document.querySelectorAll('[data-color-dropdown][open]').forEach(dropdown=>{if(!dropdown.contains(event.target))closeDropdown(dropdown);});
 });
 document.addEventListener('keydown',event=>{
  const dropdown=event.target.closest('[data-color-dropdown]');if(!dropdown)return;
  const summary=dropdown.querySelector('summary');
  if(event.key==='Escape'){if(dropdown.open){event.preventDefault();closeDropdown(dropdown);summary.focus({preventScroll:true});}return;}
  if(!['ArrowDown','ArrowUp','Home','End'].includes(event.key))return;
  event.preventDefault();if(!dropdown.open){dropdown.open=true;placePanel(dropdown);}
  const options=[...dropdown.querySelectorAll('[role=option]')];
  const current=options.indexOf(document.activeElement),selected=options.findIndex(button=>button.getAttribute('aria-selected')==='true');
  const index=event.key==='Home'?0:event.key==='End'?options.length-1:current<0?Math.max(0,selected):(current+(event.key==='ArrowDown'?1:-1)+options.length)%options.length;
  options[index]?.focus({preventScroll:true});
 });
 document.addEventListener('focusin',event=>document.querySelectorAll('[data-color-dropdown][open]').forEach(dropdown=>{if(!dropdown.contains(event.target))closeDropdown(dropdown);}));
 window.addEventListener('resize',()=>document.querySelectorAll('[data-color-dropdown][open]').forEach(closeDropdown),{passive:true});
 document.addEventListener('scroll',event=>{if(event.target.closest?.('.mk-color-panel'))return;document.querySelectorAll('[data-color-dropdown][open]').forEach(closeDropdown);},{passive:true,capture:true});
 document.addEventListener('mk:options:refresh',()=>initialize());
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});else initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();

(() => {
 const initialize=(scope=document)=>scope.querySelectorAll('.mk-purchase-bar').forEach(bar=>{
  if(bar.dataset.stickyVisibilityReady) return;
  const primary=document.getElementById(bar.getAttribute('form'))?.querySelector('button[name="add"]');
  if(!primary) return;
  bar.dataset.stickyVisibilityReady='true';
  const dismiss=bar.querySelector('[data-sticky-dismiss]');
  const reopen=bar.nextElementSibling?.matches('[data-sticky-reopen]')?bar.nextElementSibling:null;
  if(!bar.id)bar.id='mk-purchase-'+bar.getAttribute('form');
  reopen?.setAttribute('aria-controls',bar.id);
  const header=document.querySelector('header[id*="__header"]');
  const controller=new AbortController();
  let frame=0,footerSpace='';
  const update=()=>{
   frame=0;
   if(!bar.isConnected) return;
   const rect=primary.getBoundingClientRect();
   const top=Math.max(0,header?.getBoundingClientRect().bottom || 0);
   const eligible=rect.height>0 && rect.bottom<=top+2;
   const dismissed=bar.dataset.mkStickyDismissed==='true';
   const visible=!dismissed && eligible;
   // Reserve the same footer clearance in both states so hiding the bar cannot move the page end.
   const nextFooterSpace=(eligible?Math.ceil(bar.getBoundingClientRect().height)+12:0)+'px';
   if(bar.dataset.mkStickyVisible!==String(visible))bar.dataset.mkStickyVisible=String(visible);
   if(bar.inert!==!visible)bar.inert=!visible;
   if(bar.getAttribute('aria-hidden')!==String(!visible))bar.setAttribute('aria-hidden',String(!visible));
   if(reopen){const hidden=!(dismissed&&eligible);if(reopen.hidden!==hidden)reopen.hidden=hidden;if(reopen.getAttribute('aria-expanded')!==String(visible))reopen.setAttribute('aria-expanded',String(visible));}
   if(nextFooterSpace!==footerSpace){footerSpace=nextFooterSpace;document.documentElement.style.setProperty('--mk-footer-bar-space',footerSpace);}
  };
  const schedule=()=>{if(!frame) frame=requestAnimationFrame(update);};
  dismiss?.addEventListener('click',event=>{
   event.preventDefault();event.stopPropagation();
   bar.dataset.mkStickyDismissed='true';
   update();
   if(reopen&&!reopen.hidden)reopen.focus({preventScroll:true});
  },{signal:controller.signal});
  reopen?.addEventListener('click',event=>{
   event.preventDefault();
   delete bar.dataset.mkStickyDismissed;
   update();
   if(bar.dataset.mkStickyVisible==='true')dismiss?.focus({preventScroll:true});
  },{signal:controller.signal});
  const observer=new ResizeObserver(schedule);
  observer.observe(primary);
  observer.observe(bar);
  if(header) observer.observe(header);
  addEventListener('scroll',schedule,{passive:true,signal:controller.signal});
  addEventListener('resize',schedule,{passive:true,signal:controller.signal});
  visualViewport?.addEventListener('resize',schedule,{passive:true,signal:controller.signal});
  header?.addEventListener('transitionend',schedule,{signal:controller.signal});
  document.addEventListener('shopify:section:unload',event=>{
   if(!event.target.contains(bar)) return;
   controller.abort();observer.disconnect();cancelAnimationFrame(frame);
  },{signal:controller.signal});
  update();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});else initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();

// Introduce the native comparison once; any interaction takes control immediately.
(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 function initialize(scope = document) {
  scope.querySelectorAll('[data-monster-comparison]').forEach(host => {
   if (host.dataset.monsterReady) return;
   host.dataset.monsterReady = 'true';
   const range = host.querySelector('input[type="range"]');
   if (!range) return;
   let stopped = false, frame;
   const stop = () => { stopped = true; cancelAnimationFrame(frame); };
   const update = () => host.style.setProperty('--mk-comparison-percent', range.value);
   update();
   range.addEventListener('input', () => { stop(); update(); });
   host.addEventListener('pointerdown', stop, { once: true });
   host.addEventListener('keydown', stop, { once: true });
   reduced.addEventListener('change', stop, { once: true });
   if (reduced.matches) return;
   const observer = new IntersectionObserver(entries => {
    if (!entries[0].isIntersecting) return;
    observer.disconnect();
    const initial = Number(range.value), start = performance.now();
    const animate = time => {
     if (stopped || document.hidden || reduced.matches) return;
     const progress = Math.min((time - start) / 1400, 1);
     const value = initial + Math.sin(progress * Math.PI * 2) * 16 * Math.sin(progress * Math.PI);
     range.value = String(Math.round(value));
     update();
     if (progress < 1) frame = requestAnimationFrame(animate);
     else { range.value = String(initial); update(); }
    };
    frame = requestAnimationFrame(animate);
   }, { threshold: .55 });
   observer.observe(host);
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
 else initialize();
 document.addEventListener('shopify:section:load', event => initialize(event.target));
})();


(() => {
 function resolveAccessoryQuantity(value,rules,previous = rules.min) {
  const min = Math.max(1,Number(rules.min) || 1), step = Math.max(1,Number(rules.step) || 1);
  const max = rules.max === '' || rules.max == null ? Number.MAX_SAFE_INTEGER : Number(rules.max);
  if(!Number.isSafeInteger(min) || !Number.isSafeInteger(step) || !Number.isSafeInteger(max) || max < min) return null;
  const raw = value === '' || !Number.isFinite(Number(value)) ? Number(previous) : Number(value);
  const ceiling = min + Math.floor((max-min)/step)*step;
  return Math.min(ceiling,Math.max(min,min + Math.round((raw-min)/step)*step));
 }
 function calculateSetupQuote(mainPrice,mainQuantity,accessories) {
  const lines = [{price:Number(mainPrice),quantity:Number(mainQuantity)},...accessories.map(item => ({price:Number(item.price),quantity:Number(item.quantity)}))];
  const valid = lines.every(line => Number.isSafeInteger(line.price) && line.price >= 0 && Number.isSafeInteger(line.quantity) && line.quantity >= 1);
  if(!valid) return {valid:false,units:0,subtotal:0,percent:0,discount:0,total:0};
  const units = lines.reduce((sum,line) => sum + line.quantity,0);
  const subtotal = lines.reduce((sum,line) => sum + line.price * line.quantity,0);
  if(!Number.isSafeInteger(subtotal) || !Number.isSafeInteger(units)) return {valid:false,units:0,subtotal:0,percent:0,discount:0,total:0};
  const percent = units >= 4 ? 10 : units === 3 ? 7 : units === 2 ? 5 : 0;
  // Shopify automatic-discount cart proof: fractional discount cents are truncated.
  const discount = Math.floor(subtotal * percent / 100);
  return {valid:true,units,subtotal,percent,discount,total:subtotal-discount};
 }
 function calculateSetupWithCart(setup,cartUnits,cartSubtotal) {
  cartUnits=Number(cartUnits||0);cartSubtotal=Number(cartSubtotal||0);
  if(!setup.valid||!Number.isSafeInteger(cartUnits)||cartUnits<0||!Number.isSafeInteger(cartSubtotal)||cartSubtotal<0)return {...setup,valid:false};
  const units=setup.units+cartUnits,subtotal=setup.subtotal+cartSubtotal;
  if(!Number.isSafeInteger(units)||!Number.isSafeInteger(subtotal))return {...setup,valid:false};
  const percent=units>=4?10:units===3?7:units===2?5:0,discount=Math.floor(subtotal*percent/100);
  return {valid:true,units,subtotal,percent,discount,total:subtotal-discount,selectedUnits:setup.units};
 }
 function setText(element,value) {
  const text=String(value);if(element && element.textContent!==text) element.textContent=text;
 }
 function setAttribute(element,name,value) {
  if(value===null){if(element.hasAttribute(name))element.removeAttribute(name);}
  else if(element.getAttribute(name)!==String(value))element.setAttribute(name,String(value));
 }
 function setProperty(element,name,value) {
  if(element[name]!==value)element[name]=value;
 }
 function setStyle(element,name,value) {
  if(element.style.getPropertyValue(name)!==value)element.style.setProperty(name,value);
 }
 function initialize(scope = document) {
  scope.querySelectorAll('[data-monster-bundle]').forEach(host => {
   if(host.dataset.bundleReady) return;
   const form = document.getElementById(host.dataset.formId);
   if(!form) return;
   host.dataset.bundleReady = 'true';
   const disclosureEvents = new AbortController();
   const listen=(target,type,handler,options={})=>target?.addEventListener(type,handler,{...(options===true?{capture:true}:options),signal:disclosureEvents.signal});
   const inputs = [...host.querySelectorAll('[data-bundle-item]')];
   const status = host.querySelector('[data-bundle-status]');
   const button = host.querySelector('[data-bundle-add]');
   const buttonText = button.querySelector('[data-bundle-add-label]');
   const originalText = buttonText.textContent;
   const error = host.querySelector('[data-bundle-error]');
   const variants = JSON.parse(host.querySelector('[data-bundle-variants]').textContent);
   let busy = false;
   const sticky=[...document.querySelectorAll('.mk-purchase-bar')].find(bar=>bar.getAttribute('form')===host.dataset.formId);
   const stickyBundle=sticky?.querySelector('[data-sticky-bundle-add]');
   const stickyNormal=sticky?.querySelector('button[name="add"]');
   const stickyQuantity=sticky?.querySelector('[name="quantity"]');
   const mainQuantity=form?.querySelector('[name="quantity"]');
   let syncingStickyQuantity=false;
   const syncStickyQuantity=event=>{
    if(syncingStickyQuantity || !mainQuantity || !stickyQuantity || event.target!==stickyQuantity) return;
    syncingStickyQuantity=true;
    mainQuantity.value=stickyQuantity.value;
    mainQuantity.dispatchEvent(new Event(event.type,{bubbles:true}));
    syncingStickyQuantity=false;
   };
   listen(stickyQuantity,'input',syncStickyQuantity);
   listen(stickyQuantity,'change',syncStickyQuantity);
   listen(stickyBundle,'click',()=>{if(!busy && !button.disabled) button.click();});
   const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
   const savings = host.querySelector('[data-bundle-saved]');
   const totalElement = host.querySelector('[data-bundle-total]');
   const feedbackAnimations = new Map();
   const disclosure = host.querySelector('[data-setup-disclosure]');
   const disclosureTrigger = disclosure?.querySelector('summary');
   const disclosurePanel = disclosure?.querySelector('[data-setup-reveal]');
   let disclosureAnimation = null;
   let disclosureExpanded = !!disclosure?.open;
   let disclosureTarget = 0;
   let disclosureRevision = 0;
   const disclosureContent=disclosurePanel?.firstElementChild;
   let disclosureNatural=null;
   const naturalDisclosureHeight = (refresh=false,entry=null) => {
    if(disclosureNatural!==null && !refresh) return disclosureNatural;
    const panelStyle=getComputedStyle(disclosurePanel),contentStyle=disclosureContent && getComputedStyle(disclosureContent);
    // This single normal-flow child owns the reveal's full height, including its gap.
    if(disclosurePanel.children.length===1 && panelStyle.display==='flow-root' && panelStyle.writingMode==='horizontal-tb' && contentStyle.position!=='absolute' && contentStyle.position!=='fixed' && contentStyle.transform==='none' && contentStyle.zoom==='1'){
     const size=entry?.borderBoxSize,box=Array.isArray(size)?size[0]:size;
     const height=box?.blockSize ?? disclosureContent.getBoundingClientRect().height;
     disclosureNatural=height+['marginTop','marginBottom'].reduce((sum,key)=>sum+(parseFloat(contentStyle[key])||0),0)+['paddingTop','paddingBottom','borderTopWidth','borderBottomWidth'].reduce((sum,key)=>sum+(parseFloat(panelStyle[key])||0),0);
    }else{
     // Preserve the legacy measurement for other merchant/older wrapper layouts.
     const height=disclosurePanel.style.height,animation=disclosureAnimation,effect=animation?.effect;
     if(animation) animation.effect=null;
     disclosurePanel.style.height='auto';
     disclosureNatural=disclosurePanel.getBoundingClientRect().height;
     disclosurePanel.style.height=height;
     if(animation) animation.effect=effect;
    }
    return disclosureNatural;
   };
   const finishDisclosure = () => {
    if(!disclosure) return;
    setProperty(disclosure,'open',disclosureExpanded);
    if(disclosure.classList.contains('is-animating')) disclosure.classList.remove('is-animating');
    disclosureTarget=disclosureExpanded?naturalDisclosureHeight():0;
    setStyle(disclosurePanel,'height',disclosureExpanded?disclosureTarget+'px':'');
    setStyle(disclosurePanel,'opacity','');
    setAttribute(disclosureTrigger,'aria-expanded',String(disclosureExpanded));
    setProperty(disclosurePanel,'inert',!disclosureExpanded);
   };
   const openDisclosure = (expanded,animate = true,resize = false) => {
    if(!disclosure || (!resize && expanded === disclosureExpanded && !disclosureAnimation)) return;
    // Capture both channels before cancellation, including rapid reversals.
    const start = disclosure.open ? disclosurePanel.getBoundingClientRect().height : 0;
    const opacity = disclosure.open ? Number(getComputedStyle(disclosurePanel).opacity) : 0;
    const revision = ++disclosureRevision;
    disclosureAnimation?.cancel();
    disclosureAnimation = null;
    disclosureExpanded = expanded;
    if(expanded) disclosure.open = true;
    else if(disclosurePanel.contains(document.activeElement)) disclosureTrigger.focus({preventScroll:true});
    disclosureTrigger.setAttribute('aria-expanded',String(expanded));
    disclosurePanel.inert = !expanded;
    const end = expanded ? naturalDisclosureHeight() : 0;
    disclosureTarget = end;
    if(reducedMotion.matches || !animate){finishDisclosure();return;}
    disclosure.classList.add('is-animating');
    disclosurePanel.style.height = end+'px';
    disclosurePanel.style.opacity = expanded ? '1' : '0';
    const animation = disclosurePanel.animate([
     {height:start+'px',opacity},
     {height:end+'px',opacity:expanded ? 1 : 0}
    ],{duration:Math.max(90,(expanded?320:260)*Math.min(1,Math.abs(end-start)/Math.max(end,start,1))),easing:'cubic-bezier(.25,.1,.25,1)',fill:'both'});
    animation.startTime=performance.now();
    disclosureAnimation = animation;
    animation.onfinish = () => {
     if(disclosureAnimation !== animation || revision !== disclosureRevision) return;
     disclosureAnimation = null;
     animation.cancel();
     finishDisclosure();
    };
   };
   if(disclosurePanel){
    const sizeObserver = new ResizeObserver(entries => {
     if(disclosureEvents.signal.aborted || !disclosureExpanded || !disclosure.open || !host.isConnected) return;
     disclosureNatural=null;
     const natural = naturalDisclosureHeight(true,entries[0]);
     if(Math.abs(natural-disclosureTarget)>1) openDisclosure(true,true,true);
    });
    if(disclosurePanel.firstElementChild) sizeObserver.observe(disclosurePanel.firstElementChild);
    // Width changes invalidate the cached natural height, not every open/close.
    let measuredWidth=null;
    const widthObserver=new ResizeObserver(entries=>{
     const width=entries[0].contentRect.width;
     if(measuredWidth!==null && Math.abs(width-measuredWidth)>.5) disclosureNatural=null;
     measuredWidth=width;
    });
    widthObserver.observe(disclosureTrigger);
    disclosureEvents.signal.addEventListener('abort',()=>{sizeObserver.disconnect();widthObserver.disconnect();},{once:true});
   }
   if(disclosure){
    finishDisclosure();
    listen(disclosureTrigger,'click',event=>{
     event.preventDefault();openDisclosure(!disclosureExpanded);
    },{signal:disclosureEvents.signal});
    listen(disclosure,'toggle',()=>{
     if(disclosureAnimation) return;
     disclosureExpanded = disclosure.open;finishDisclosure();
    },{signal:disclosureEvents.signal});
    listen(host,'mk:setup:open',()=>openDisclosure(true),{signal:disclosureEvents.signal});
   }

   host.classList.add('is-motion-paused');
   const motionObserver = new IntersectionObserver(entries => {
    const visible = entries[0].isIntersecting;
    host.classList.toggle('is-motion-paused',!visible);
    if(visible && host.matches('.mk-bundle-studio')) host.classList.add('is-studio-visible');
   },{threshold:.1});
   motionObserver.observe(host);
   const studioActions = host.querySelector('.mk-studio-actions');
   const studioActionsObserver = studioActions ? new IntersectionObserver(entries => {
    host.classList.toggle('is-studio-actions-visible',entries[0].isIntersecting);
   },{threshold:0}) : null;
   if(studioActionsObserver) studioActionsObserver.observe(studioActions);
   const quoteLines = new Map([...host.querySelectorAll('[data-quote-line]')].map(line => [line.dataset.productId,line]));
   const studioGrid = host.querySelector('.mk-bundle-grid');
   const studioNavigation = host.querySelector('[data-studio-navigation]');
   let studioResize,navigationFrame=0,statusFrame=0;
   const attentionFrames=new Set();
   let finishRailDrag=()=>{};
   const alignSetupLinks = () => {
    host.querySelectorAll('[data-studio-link]').forEach(button => {
     const card=button.closest('[data-bundle-card]'),next=card?.nextElementSibling;
     if(!next?.matches('[data-bundle-card]') || !button.getClientRects().length)return;
     const currentRect=card.getBoundingClientRect(),nextRect=next.getBoundingClientRect(),buttonRect=button.getBoundingClientRect(),style=getComputedStyle(card);
     if(!card.offsetWidth || !buttonRect.width) return;
     const gapCenter=(currentRect.right+nextRect.left)/2;
     const scale=currentRect.width/card.offsetWidth || 1;
     button.style.setProperty('--mk-link-x',((gapCenter-currentRect.left-buttonRect.width/2)/scale-parseFloat(style.borderLeftWidth))+'px');
     button.style.setProperty('--mk-link-y',((currentRect.height-buttonRect.height)/2/scale-parseFloat(style.borderTopWidth))+'px');
    });
   };
   if(studioNavigation){
    const previous = studioNavigation.querySelector('[data-studio-prev]');
    const next = studioNavigation.querySelector('[data-studio-next]');
    const updateNavigation = () => {
     if(!studioGrid.clientWidth) return;
     alignSetupLinks();
     const max = studioGrid.scrollWidth - studioGrid.clientWidth;
     const offset = Math.abs(studioGrid.scrollLeft);
     studioNavigation.hidden = max < 3;
     previous.disabled = offset < 3;
     next.disabled = offset >= max - 3;
     studioNavigation.querySelector('[data-studio-scroll-progress]').style.width = Math.min(100,studioGrid.clientWidth / studioGrid.scrollWidth * 100) + '%';
     const direction = getComputedStyle(studioGrid).direction === 'rtl' ? -1 : 1;
     studioNavigation.querySelector('[data-studio-scroll-progress]').style.transform = 'translateX(' + (max > 0 ? offset / studioGrid.clientWidth * 100 * direction : 0) + '%)';
    };
    const move = direction => {
     const rtl = getComputedStyle(studioGrid).direction === 'rtl';
     const card = studioGrid.querySelector('[data-bundle-card]');
     if(!card)return;
     const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(studioGrid).columnGap || '0');
     studioGrid.scrollBy({left:direction * step * (rtl ? -1 : 1),behavior:reducedMotion.matches ? 'instant' : 'smooth'});
    };
    listen(previous,'click',() => move(-1));
    listen(next,'click',() => move(1));
    host.querySelectorAll('[data-studio-link]').forEach(button=>listen(button,'click',()=>{
     const cards=[...studioGrid.querySelectorAll('[data-bundle-card]')],current=cards.indexOf(button.closest('[data-bundle-card]'));
     const target=cards[(current+1)%cards.length];
     if(!target)return;
     if(matchMedia('(max-width:767px)').matches)studioGrid.scrollBy({left:target.getBoundingClientRect().left-studioGrid.getBoundingClientRect().left,behavior:reducedMotion.matches?'instant':'smooth'});
     else target.querySelector('.mk-bundle-select')?.focus({preventScroll:true});
     target.classList.remove('mk-pick-attention');
     const frame=requestAnimationFrame(()=>{attentionFrames.delete(frame);if(disclosureEvents.signal.aborted)return;target.classList.add('mk-pick-attention');listen(target,'animationend',()=>target.classList.remove('mk-pick-attention'),{once:true});});attentionFrames.add(frame);
    }));
    listen(studioGrid,'keydown',event=>{if(event.target!==studioGrid)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
    const scheduleNavigation=()=>{if(!navigationFrame)navigationFrame=requestAnimationFrame(()=>{navigationFrame=0;updateNavigation();});};
    listen(studioGrid,'scroll',scheduleNavigation,{passive:true});
    studioResize = new ResizeObserver(scheduleNavigation);
    studioResize.observe(studioGrid);
    updateNavigation();
   }
   const celebrate = (element,frames) => {
    if(!element || reducedMotion.matches || !host.isConnected) return;
    feedbackAnimations.get(element)?.cancel();
    const animation = element.animate(frames,{duration:420,easing:'cubic-bezier(.2,.7,.2,1)'});
    feedbackAnimations.set(element,animation);
    animation.onfinish = () => feedbackAnimations.delete(element);
   };
   listen(reducedMotion,'change',() => {
    feedbackAnimations.forEach(animation => animation.cancel());feedbackAnimations.clear();
    if(disclosureAnimation){disclosureAnimation.cancel();disclosureAnimation=null;finishDisclosure();}
   },{signal:disclosureEvents.signal});
   if(!form) return;
   const mainItem = () => {
    const data = new FormData(form), variant = variants.find(item => String(item.id) === String(data.get('id')));
    return {data, variant, quantity:Number(data.get('quantity') || variant?.quantity_rule?.min || 1)};
   };
   const money = {format: amount => window.MonsterMoney.format(Math.round(amount * 100))};
   const preview = host.querySelector('[data-bundle-dialog]');
   const quantityDrafts = new Map();
   let previewCard = null, previewTrigger = null, previewLightbox = null, galleryOpening = false;
   const quantityRules = input => ({min:input.dataset.min,step:input.dataset.step,max:input.dataset.max});
   const unitsLabel=count=>(count === 1 ? host.dataset.unitLabel : host.dataset.unitsLabel).replace('[count]',String(count));
   const selectedQuote=()=>{
    const main=mainItem(), extras=inputs.filter(item=>item.checked && !item.disabled);
    if(extras.some(item=>quantityDrafts.has(item))) return calculateSetupQuote(NaN,main.quantity,[]);
    const setup=calculateSetupQuote(main.variant?.price ?? host.dataset.basePrice,main.quantity,extras.map(item=>({price:item.dataset.price,quantity:item.dataset.quantity})));
    // This purchase surface quotes only newly selected setup lines, never existing cart contents.
    return setup;
   };
   // Preview the next earned connection without changing selection or the quote.
   let tierHover = null, tierFocus = null;
   const updateTierConnections = () => {
    const earned = Math.min(3,Math.max(0,Number(host.dataset.quoteUnits || 1)-1));
    const candidate = tierHover || tierFocus;
    const input = candidate?.querySelector('[data-bundle-item]');
    const extra = input && !input.checked && !input.disabled && !quantityDrafts.has(input) ? Number(input.dataset.quantity || 1) : 0;
    const projected = Math.min(3,Math.max(earned,Number(host.dataset.quoteUnits || 1)+extra-1));
    setStyle(host,'--mk-tier-link-one',projected >= 2 ? '1' : '0');
    setStyle(host,'--mk-tier-link-two',projected >= 3 ? '1' : '0');
    setStyle(host,'--mk-tier-link-one-opacity',earned >= 2 ? '1' : '.5');
    setStyle(host,'--mk-tier-link-two-opacity',earned >= 3 ? '1' : '.5');
   };
   host.querySelectorAll('[data-bundle-card]').forEach(card => {
    listen(card,'pointerenter',event => {if(event.pointerType !== 'touch'){tierHover=card;updateTierConnections();}});
    listen(card,'pointerleave',() => {if(tierHover===card)tierHover=null;updateTierConnections();});
    listen(card,'focusin',() => {tierFocus=card;updateTierConnections();});
    listen(card,'focusout',event => {if(!card.contains(event.relatedTarget)){tierFocus=null;updateTierConnections();}});
   });
   if(studioGrid){
    let railDrag = null, suppressRailClick = false;
    listen(studioGrid,'pointerdown',event => {
     suppressRailClick=false;
     if(event.pointerType==='touch' || event.button!==0 || studioGrid.scrollWidth <= studioGrid.clientWidth+2 || event.target.closest('input,select,textarea,[data-bundle-preview],[data-quantity-step],[data-demo-select]'))return;
     railDrag={id:event.pointerId,x:event.clientX,y:event.clientY,left:studioGrid.scrollLeft,scale:studioGrid.getBoundingClientRect().width/studioGrid.clientWidth || 1,active:false};
    });
    listen(studioGrid,'pointermove',event => {
     if(!railDrag || railDrag.id!==event.pointerId)return;
     const dx=event.clientX-railDrag.x,dy=event.clientY-railDrag.y;
     if(!railDrag.active && Math.abs(dy)>Math.abs(dx)+8){railDrag=null;return;}
     if(!railDrag.active && Math.abs(dx)>8){
      railDrag.active=true;suppressRailClick=true;studioGrid.setPointerCapture(event.pointerId);studioGrid.classList.add('is-dragging');
     }
     if(railDrag.active){event.preventDefault();studioGrid.scrollLeft=railDrag.left-dx/railDrag.scale;}
    });
    finishRailDrag = () => {
     if(railDrag && studioGrid.hasPointerCapture(railDrag.id))studioGrid.releasePointerCapture(railDrag.id);
     railDrag=null;studioGrid.classList.remove('is-dragging');
    };
    listen(studioGrid,'pointerup',finishRailDrag);
    listen(studioGrid,'pointercancel',finishRailDrag);
    listen(studioGrid,'lostpointercapture',finishRailDrag);
    listen(studioGrid,'pointerleave',() => {if(!railDrag?.active)railDrag=null;});
    listen(studioGrid,'dragstart',event => event.preventDefault());
    listen(studioGrid,'click',event => {if(suppressRailClick && event.detail!==0){event.preventDefault();event.stopImmediatePropagation();}suppressRailClick=false;},true);
   }
   const syncQuantityControl = (container,input) => {
    const control = container?.querySelector('[data-bundle-quantity],[data-preview-quantity]');
    if(!control) return;
    const {min,step,max} = quantityRules(input), quantity = Number(input.dataset.quantity);
    setProperty(control,'min',min); setProperty(control,'step',step);
    if(max !== '') setProperty(control,'max',max); else setAttribute(control,'max',null);
    if(document.activeElement !== control) setProperty(control,'value',quantityDrafts.get(input) ?? input.dataset.quantity);
    setAttribute(control,'aria-invalid',String(quantityDrafts.has(input)));
    const warning=container.querySelector('[data-quantity-error]');
    setProperty(warning,'hidden',!quantityDrafts.has(input));
    setText(warning,quantityDrafts.has(input) ? control.validationMessage : '');
    const limit=container.querySelector('[data-quantity-limit]');
    setProperty(limit,'hidden',max === '' || quantity < Number(max) || quantityDrafts.has(input));
    setText(limit,max !== '' ? host.dataset.limitLabel.replace('[count]',String(max)) : '');
    setProperty(control,'disabled',busy || input.disabled);
    setProperty(container.querySelector('[data-quantity-step="-1"]'),'disabled',busy || input.disabled || quantity <= Number(min));
    setProperty(container.querySelector('[data-quantity-step="1"]'),'disabled',busy || input.disabled || (max !== '' && quantity + Number(step) > Number(max)));
   };
   const changeAccessoryQuantity = (card,value) => {
    const input=card?.querySelector('[data-bundle-item]');
    if(!input || busy || input.disabled) return;
    const quantity=resolveAccessoryQuantity(value,quantityRules(input),input.dataset.quantity);
    if(quantity === null) return;
    quantityDrafts.delete(input);
    input.dataset.quantity=String(quantity);
    card.querySelector('[data-bundle-quantity]').value=String(quantity);
    if(previewCard === card && preview?.querySelector('[data-preview-quantity]')) preview.querySelector('[data-preview-quantity]').value=String(quantity);
    update(true);
   };
   const syncPreview = () => {
    if(!previewCard || !preview) return;
    const input = previewCard.querySelector('[data-bundle-item]');
    const select = preview.querySelector('[data-preview-select]');
    if(select){
     setText(select,input.checked ? select.dataset.removeLabel : select.dataset.addLabel);
     setAttribute(select,'aria-pressed',String(input.checked));
     setProperty(select,'disabled',busy || (!input.checked && (input.disabled || quantityDrafts.has(input))));
    }
    setText(preview.querySelector('[data-preview-price]'),money.format(Number(input.dataset.price)/100));
    syncQuantityControl(preview,input);
    const cardSelect = previewCard.querySelector('[data-bundle-variant]');
    const previewSelect = preview.querySelector('[data-preview-variant]');
    if(cardSelect && previewSelect) setProperty(previewSelect,'value',cardSelect.value);
   };
   const setPreviewImage = (url,alt) => {
    const image = preview.querySelector('.mk-preview-image img');
    if(!image || !url) return;
    image.removeAttribute('srcset'); image.src = url;
    if(alt) image.alt = alt;
    preview.querySelectorAll('[data-preview-image]').forEach(thumb => thumb.setAttribute('aria-pressed',String(thumb.dataset.previewImage === url)));
   };
   const openPreviewGallery = async () => {
    if(galleryOpening || !preview?.open) return;
    const image=preview.querySelector('.mk-preview-image img');
    const items=[...preview.querySelectorAll('[data-preview-gallery-items]>span')].map(item=>({src:item.dataset.src,previewSrc:item.dataset.previewSrc,thumbSrc:item.dataset.thumbSrc,width:Number(item.dataset.width),height:Number(item.dataset.height),alt:item.dataset.alt}));
    if(!image || !items.length) return;
    galleryOpening=true;
    try {
     if(!previewLightbox){
      const {Lightbox}=await import('@theme/zoom-psw');
      if(disclosureEvents.signal.aborted) return;
      const labels=window.themeHDN?.extras?.pswp || {};
      const svg='<svg aria-hidden="true" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" class="pswp__icn">';
      const duration=reducedMotion.matches?0:280;
      previewLightbox=new Lightbox({pswpModule:()=>import('@theme/psw'),bgOpacity:1,zoom:false,secondaryZoomLevel:2,maxZoomLevel:3,showHideAnimationType:'fade',showAnimationDuration:duration,hideAnimationDuration:duration,zoomAnimationDuration:duration,returnFocus:false,closeTitle:labels.close,zoomTitle:labels.zoom,arrowPrevTitle:labels.prev,arrowNextTitle:labels.next,errorMsg:labels.errorMsg,
       paddingFn:viewport=>({top:80,bottom:viewport.x<768?98:116,left:viewport.x<768?14:80,right:viewport.x<768?14:80}),
       arrowPrevSVG:svg+'<path d="m15 18-6-6 6-6"/></svg>',arrowNextSVG:svg+'<path d="m9 18 6-6-6-6"/></svg>',closeSVG:svg+'<path d="m6 6 12 12M18 6 6 18"/></svg>',zoomSVG:svg+'<circle cx="10" cy="10" r="7"/><path d="m15 15 6 6M10 6v8M6 10h8"/></svg>'});
      previewLightbox.on('uiRegister',()=>{
       const pswp=previewLightbox.pswp;
       (pswp.element || pswp.template).dataset.palette=host.closest('[data-monster-product]')?.dataset.palette || 'mecha';
       if(pswp.getNumItems()<2) return;
       pswp.ui.registerElement({name:'preview-thumbnails',className:'pswp__thumbnails mk-preview-lightbox-thumbs',appendTo:'root',onInit:(el,instance)=>{
        instance.options.dataSource.forEach((item,index)=>{
         const button=document.createElement('button'),thumb=document.createElement('img');
         button.type='button';button.className='pswp__thumbnail';button.setAttribute('aria-label',preview.querySelectorAll('[data-preview-image]')[index]?.getAttribute('aria-label') || String(index+1));
         thumb.src=item.thumbSrc;thumb.alt=item.alt;thumb.width=70;thumb.height=70;button.append(thumb);listen(button,'click',()=>instance.goTo(index));el.append(button);
        });
        const sync=()=>[...el.children].forEach((button,index)=>{button.classList.toggle('pswp__thumbnail--active',index===instance.currIndex);button.setAttribute('aria-pressed',String(index===instance.currIndex));if(index===instance.currIndex)button.scrollIntoView({block:'nearest',inline:'nearest'});});
        instance.on('change',sync);sync();
       }});
      });
      previewLightbox.on('change',()=>{const instance=previewLightbox.pswp,item=instance.options.dataSource[instance.currIndex];if(item)setPreviewImage(item.previewSrc,item.alt);});
      previewLightbox.on('destroy',()=>{
       if(disclosureEvents.signal.aborted || !preview.isConnected || !previewCard?.isConnected) return;
       preview.showModal();document.documentElement.setAttribute('data-mk-bundle-lock','');preview.querySelector('[data-preview-open-image]')?.focus({preventScroll:true});
      });
      previewLightbox.init();
     }
     if(disclosureEvents.signal.aborted || !preview.open) return;
     const path=url=>new URL(url,location.href).pathname;
     const index=Math.max(0,items.findIndex(item=>path(item.previewSrc)===path(image.src)));
     preview.close();
     previewLightbox.loadAndOpen(index,items);
    } catch(error){
     if(disclosureEvents.signal.aborted)return;
     if(!preview.open){preview.showModal();document.documentElement.setAttribute('data-mk-bundle-lock','');}
     console.error('Product image preview could not open',error);
    } finally {galleryOpening=false;}
   };
   if(preview){
    listen(preview,'pointermove',event => {
     const frame=event.target.closest('.mk-preview-image');
     if(!frame || event.pointerType==='touch' || !matchMedia('(hover:hover)').matches) return;
     const rect=frame.getBoundingClientRect(), image=frame.querySelector('img');
     if(image) image.style.transformOrigin=((event.clientX-rect.left)/rect.width*100)+'% '+((event.clientY-rect.top)/rect.height*100)+'%';
    });
    listen(preview,'close',() => {
     document.documentElement.removeAttribute('data-mk-bundle-lock');
     if(previewTrigger?.isConnected) previewTrigger.focus({preventScroll:true});
    });
    listen(preview,'click',event => {
     if(event.target.closest('[data-preview-close]')) {preview.close(); return;}
     if(event.target.closest('[data-preview-open-image]')) {openPreviewGallery(); return;}
     const step=event.target.closest('[data-quantity-step]');
     if(step){
      const input=previewCard.querySelector('[data-bundle-item]');
      changeAccessoryQuantity(previewCard,Number(input.dataset.quantity)+Number(step.dataset.quantityStep)*Number(input.dataset.step));
      return;
     }
     const thumbnail = event.target.closest('[data-preview-image]');
     if(thumbnail) {setPreviewImage(thumbnail.dataset.previewImage,thumbnail.dataset.imageAlt); return;}
     if(event.target.closest('[data-preview-select]')) {
      const input = previewCard.querySelector('[data-bundle-item]');
      if(busy || (!input.checked && (input.disabled || quantityDrafts.has(input)))) return;
      input.checked=!input.checked;
      if(!input.checked) quantityDrafts.delete(input);
      input.dispatchEvent(new Event('change',{bubbles:true}));
      preview.querySelector('[data-preview-feedback]').textContent = preview.querySelector('[data-preview-select]').textContent;
      return;
     }
     if(event.target === preview){
      const rect = preview.getBoundingClientRect();
      if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) preview.close();
     }
    });
    listen(preview,'change',event => {
     if(event.target.matches('[data-preview-quantity]')){changeAccessoryQuantity(previewCard,event.target.value);return;}
     if(!event.target.matches('[data-preview-variant]')) return;
     const select = previewCard.querySelector('[data-bundle-variant]');
     select.value = event.target.value;
     select.dispatchEvent(new Event('change',{bubbles:true}));
     setPreviewImage(select.selectedOptions[0].dataset.image);
    });
   }
   listen(host,'click',event => {
    if(event.target.closest('[data-bundle-dialog],[data-studio-link],[data-mk-preview-options],[data-studio-preview],[data-studio-dialog],[data-studio-details],[data-studio-options],[data-studio-main-card],[data-studio-wave]')) return;
    const review=event.target.closest('[data-setup-review]');
    if(review){const heading=host.querySelector('[data-setup-summary-heading]');heading.scrollIntoView({block:'start',behavior:reducedMotion.matches ? 'instant' : 'smooth'});heading.focus({preventScroll:true});return;}
    if(busy && event.target.closest('.mk-bundle-select')){event.preventDefault();return;}
    const clear = event.target.closest('[data-setup-clear]');
    const remove = event.target.closest('[data-setup-remove]');
    if(clear || remove){
     if(busy) return;
     if(clear){quantityDrafts.clear();inputs.forEach(input => {input.checked=false;});update(true);}
     else {
      const input = inputs.find(item => item.dataset.productId === remove.dataset.productId);
      if(input?.checked){input.checked=false;quantityDrafts.delete(input);update(true);}
     }
     const nextFocus = [...host.querySelectorAll('[data-setup-remove]')].find(button => button.closest('[data-quote-line]')?.hidden===false) || host.querySelector('[data-setup-summary-heading]');
     nextFocus?.focus({preventScroll:true});
     return;
    }
    const card = event.target.closest('[data-bundle-card]');
    if(!card) return;
    const quantityControl=event.target.closest('[data-accessory-quantity]');
    if(quantityControl){
     const step=event.target.closest('[data-quantity-step]'), input=card.querySelector('[data-bundle-item]');
     if(step) changeAccessoryQuantity(card,Number(input.dataset.quantity)+Number(step.dataset.quantityStep)*Number(input.dataset.step));
     return;
    }
    const eye = event.target.closest('[data-bundle-preview]');
    if(eye && preview){
     previewCard=card; previewTrigger=eye;
     preview.querySelector('[data-preview-body]').replaceChildren(card.querySelector('[data-bundle-preview-content]').content.cloneNode(true));
     preview.querySelectorAll('img').forEach(image=>{image.loading='eager';});
     if(eye.hasAttribute('data-preview-details')) preview.querySelector('.mk-preview-description')?.setAttribute('open','');
     preview.querySelector('[data-preview-feedback]').textContent='';
     preview.setAttribute('aria-label',card.querySelector('.mk-bundle-name').textContent);
     document.dispatchEvent(new CustomEvent('mk:options:refresh'));
     syncPreview();
     const variantImage=card.querySelector('[data-bundle-variant]')?.selectedOptions[0].dataset.image;
     if(variantImage) setPreviewImage(variantImage);
     preview.showModal(); preview.scrollTop=0;
     document.documentElement.setAttribute('data-mk-bundle-lock','');
     return;
    }
    if(event.target.closest('select,input')) return;
    const input=card.querySelector('[data-bundle-item]');
    event.preventDefault();
    if(busy || input.disabled || (!input.checked && quantityDrafts.has(input))) return;
    input.checked=!input.checked;
    if(!input.checked) quantityDrafts.delete(input);
    input.dispatchEvent(new Event('change',{bubbles:true}));
    return;
   });
   const unloadPreview = event => {
    if(!event.target.contains(host)) return;
    if(preview?.open){preview.close();document.documentElement.removeAttribute('data-mk-bundle-lock');}
    disclosureEvents.abort();disclosureAnimation?.cancel();disclosureAnimation=null;
    if(disclosure) finishDisclosure();
    if(busy){busy=false;button.removeAttribute('aria-busy');setText(buttonText,originalText);}
    previewLightbox?.destroy?.();
    cancelAnimationFrame(quoteFrame);quoteFrame=0;
    cancelAnimationFrame(navigationFrame);navigationFrame=0;
    cancelAnimationFrame(statusFrame);statusFrame=0;
    attentionFrames.forEach(cancelAnimationFrame);attentionFrames.clear();
    finishRailDrag();
    quoteObserver.disconnect();
    delete host.dataset.bundleReady;
    feedbackAnimations.forEach(animation=>animation.cancel());feedbackAnimations.clear();
    motionObserver.disconnect();
    studioActionsObserver?.disconnect();
    studioResize?.disconnect();
    document.removeEventListener('shopify:section:unload',unloadPreview);
   };
   listen(document,'shopify:section:unload',unloadPreview);
   let quoteFrame=0,lastFeedbackState='';
   // Keep the visible quantity total in the input event; coalesce the rest of the quote.
   const syncImmediateProductPrice=()=>{
    const main=mainItem(),single=calculateSetupQuote(main.variant?.price ?? host.dataset.basePrice,main.quantity,[]);
    for(const price of [form.querySelector('.mk-atc-price'),sticky?.querySelector('hdt-qty-price')].filter(Boolean)){
     setAttribute(price,'variant-price',String(single.valid?single.total/main.quantity:0));
     setText(price.querySelector('.hdt-money'),single.valid?money.format(single.total/100):'—');
    }
    const discount=form.querySelector('[data-main-discount]');
    if(discount){setProperty(discount,'hidden',!single.valid||!single.percent);setText(discount.querySelector('[data-main-original-price]'),single.valid?money.format(single.subtotal/100):'');setText(discount.querySelector('[data-main-saving-rate]'),discount.dataset.savingLabel.replace('[percent]',single.percent));discount.closest('.mk-product-atc').classList.toggle('has-quantity-discount',!discount.hidden);}
   };
   const queueQuote=()=>{if(!quoteFrame && !disclosureEvents.signal.aborted && host.isConnected)quoteFrame=requestAnimationFrame(()=>{quoteFrame=0;update();});};
   const update = (animate = false) => {
    if(disclosureEvents.signal.aborted) return;
    cancelAnimationFrame(quoteFrame);quoteFrame=0;
    host.querySelectorAll('[data-bundle-variant]').forEach(select => {
     const option = select.selectedOptions[0], input = select.closest('.mk-bundle-card').querySelector('[data-bundle-item]');
     const changed=input.dataset.variantId !== option.value;
     setProperty(input.dataset,'variantId',option.value); setProperty(input.dataset,'price',option.dataset.price);
     setProperty(input.dataset,'min',option.dataset.min); setProperty(input.dataset,'step',option.dataset.step); setProperty(input.dataset,'max',option.dataset.max);
     setProperty(input,'disabled',option.disabled);
     if(changed) setProperty(input.dataset,'quantity',String(resolveAccessoryQuantity(input.dataset.quantity,quantityRules(input),option.dataset.quantity) ?? option.dataset.quantity));
     setText(select.closest('.mk-bundle-card').querySelector('[data-bundle-unit-price]'),money.format(Number(option.dataset.price)/100));
    });
    inputs.forEach(input => {
     setText(input.closest('.mk-bundle-card').querySelector('[data-bundle-unit-price]'),window.MonsterMoney.format(input.dataset.price));
     if(resolveAccessoryQuantity(input.dataset.quantity,quantityRules(input)) === null){setProperty(input,'disabled',true);setProperty(input,'checked',false);}
    });
    const selected = inputs.filter(input => input.checked && !input.disabled);
    const main = mainItem(), count = selected.length;
    const disclosureSelection = host.querySelector('[data-setup-selection-summary]');
    if(disclosureSelection){
     const selectionText = count === 1 ? disclosureSelection.dataset.one : disclosureSelection.dataset.many.replace('[count]',String(count));
     setProperty(disclosureSelection,'hidden',!count);
     if(disclosureSelection.textContent !== selectionText) disclosureSelection.textContent = selectionText;
    }
    const studioMainImage = host.querySelector('[data-studio-main-image]');
    if(studioMainImage && main.variant?.featured_image?.src){
     const source = new URL(main.variant.featured_image.src,location.origin);
     source.searchParams.set('width','160');
     if(studioMainImage.src !== source.href){studioMainImage.removeAttribute('srcset');studioMainImage.src=source.href;}
    }
    const quote = selectedQuote();
    const {units,subtotal,percent,discount,total} = quote;
    const feedbackState=JSON.stringify([quote,main.variant?.id,main.quantity,inputs.map(input=>[input.dataset.variantId,input.dataset.quantity,input.checked,input.disabled,quantityDrafts.get(input)])]);
    const quoteChanged=feedbackState!==lastFeedbackState;lastFeedbackState=feedbackState;
    const productOnly=calculateSetupQuote(main.variant?.price ?? host.dataset.basePrice,main.quantity,[]);
    const productPrice=form.querySelector('.mk-atc-price');
    if(productPrice){
     setAttribute(productPrice,'variant-price',String(productOnly.valid?productOnly.total/main.quantity:0));
     setText(productPrice.querySelector('.hdt-money'),productOnly.valid?money.format(productOnly.total/100):'—');
    }
    const productDiscount=form.querySelector('[data-main-discount]');
    if(productDiscount){
     setProperty(productDiscount,'hidden',!productOnly.valid || !productOnly.percent);
     setText(productDiscount.querySelector('[data-main-original-price]'),productOnly.valid?money.format(productOnly.subtotal/100):'');
     setText(productDiscount.querySelector('[data-main-saving-rate]'),productDiscount.dataset.savingLabel.replace('[percent]',productOnly.percent));
     productDiscount.closest('.mk-product-atc').classList.toggle('has-quantity-discount',!productDiscount.hidden);
    }
    setText(host.querySelector('[data-quote-main-price]'),money.format(Number(main.variant?.price ?? host.dataset.basePrice) * (Number.isSafeInteger(main.quantity) && main.quantity > 0 ? main.quantity : 1) / 100));
    setText(host.querySelector('[data-quote-main-quantity]'),'× ' + main.quantity);
    setText(host.querySelector('[data-quote-subtotal]'),quote.valid ? money.format(subtotal / 100) : '—');
    setProperty(host.querySelector('[data-quote-discount-row]'),'hidden',!quote.valid || !discount);
    setText(host.querySelector('[data-quote-percent]'),percent + '%');
    setText(host.querySelector('[data-quote-saving]'),'−' + money.format(discount / 100));
    setProperty(host.querySelector('[data-quote-empty]'),'hidden',count > 0);
    setProperty(host.querySelector('[data-setup-clear]'),'disabled',busy || !count);
    setProperty(host.dataset,'quoteUnits',String(units));
    setStyle(host,'--mk-earned-progress',Math.min(3,Math.max(0,units-1)) / 3 * 100 + '%');
    inputs.forEach(input => {
     const card = input.closest('.mk-bundle-card');
     const allowed=resolveAccessoryQuantity(input.dataset.quantity,quantityRules(input));
     if(allowed === null){setProperty(input,'disabled',true);setProperty(input,'checked',false);}
     syncQuantityControl(card,input);
     card.classList.toggle('is-selected',input.checked);
     card.querySelectorAll('[data-bundle-toggle]').forEach(toggle=>{
      setAttribute(toggle,'aria-pressed',String(input.checked));
      setProperty(toggle,'disabled',busy || input.disabled || (!input.checked && quantityDrafts.has(input)));
     });
     const quoteLine = quoteLines.get(input.dataset.productId);
     if(quoteLine){
      const wasHidden = quoteLine.hidden;
      setProperty(quoteLine,'hidden',!input.checked);
      setText(quoteLine.querySelector('[data-quote-line-price]'),quantityDrafts.has(input) ? '—' : money.format(Number(input.dataset.price) * Number(input.dataset.quantity || 1) / 100));
      setText(quoteLine.querySelector('[data-quote-line-quantity]'),quantityDrafts.has(input) ? host.dataset.invalidLabel : '× ' + Number(input.dataset.quantity || 1));
      if(input.checked && wasHidden && animate) celebrate(quoteLine,[{opacity:.5,transform:'translateX(6px)'},{opacity:1,transform:'translateX(0)'}]);
     }
     card.querySelector('.mk-bundle-select').classList.toggle('has-invalid-quantity',quantityDrafts.has(input));
    });
    syncPreview();
    setText(host.querySelector('[data-bundle-count]'),quote.valid ? (host.hasAttribute('data-studio-v23') ? unitsLabel(units - Number(host.dataset.existingCartUnits || 0)) + ' in this setup' : unitsLabel(units)) : host.dataset.invalidLabel);
    setStyle(host.querySelector('[data-bundle-progress]'),'width',(inputs.length ? count / inputs.length * 100 : 0) + '%');
    const selectionPercent = percent;
    setProperty(host.dataset,'discountTier',String(selectionPercent));
    const currentTier = Math.min(3,Math.max(0,units-1));
    host.querySelectorAll('[data-tier]').forEach(tier => {
     tier.classList.toggle('is-active',currentTier === Number(tier.dataset.tier));
     tier.classList.toggle('is-earned',currentTier >= Number(tier.dataset.tier));
     setAttribute(tier,'aria-current',currentTier === Number(tier.dataset.tier) ? 'step' : 'false');
     tier.classList.toggle('is-current',Number(tier.dataset.tier) === currentTier);
    });
    updateTierConnections();
    const before = host.querySelector('[data-bundle-before]');
    setProperty(before,'hidden',!percent); setText(before,money.format(subtotal / 100));
    setText(totalElement,quote.valid ? money.format(total / 100) : '—');
    if(!busy) setText(buttonText,count ? originalText : button.dataset.singleLabel);
    setText(host.querySelector('[data-quote-total-label]'),count ? host.querySelector('[data-quote-total-label]').dataset.bundleLabel : host.querySelector('[data-quote-total-label]').dataset.singleLabel);
    if(savings){setProperty(savings,'hidden',!percent);setText(savings,savings.dataset.label.replace('[amount]',money.format((subtotal-total)/100)));}
    setText(status,percent === 10 && status.dataset.maximum ? status.dataset.maximum : percent && status.dataset.next ? status.dataset.next.replace('[percent]',percent).replace('[count]',String(Math.max(0,(percent === 7 ? 4 : 3)-units))).replace('[next]',percent === 7 ? '10' : '7') : percent ? status.dataset.active.replace('[percent]',percent) : status.dataset.empty);
    setProperty(button,'disabled',busy || !quote.valid || !main.variant?.available || form.querySelector('button[name="add"]')?.disabled || !Number.isInteger(main.quantity) || main.quantity < 1);
    if(sticky){
     if(mainQuantity && stickyQuantity && stickyQuantity.value!==mainQuantity.value){
      syncingStickyQuantity=true;
      stickyQuantity.value=mainQuantity.value;
      for(const attribute of ['min','max','step']){
       const value=mainQuantity.getAttribute(attribute);
       if(value===null) setAttribute(stickyQuantity,attribute,null);else setAttribute(stickyQuantity,attribute,value);
      }
      stickyQuantity.dispatchEvent(new Event('change',{bubbles:true}));
      syncingStickyQuantity=false;
     }
     const single=calculateSetupQuote(main.variant?.price ?? host.dataset.basePrice,main.quantity,[]);
     const price=sticky.querySelector('hdt-qty-price');
     if(price){
      setAttribute(price,'variant-price',String(single.valid?single.total/main.quantity:0));
      setText(price.querySelector('.hdt-money'),single.valid?money.format(single.total/100):'—');
     }
     const rate=sticky.querySelector('[data-sticky-product-discount]');
     setText(rate,single.percent?sticky.dataset.savingLabel.replace('[percent]',single.percent):sticky.dataset.totalLabel);
     sticky.classList.toggle('has-bundle',count>0);
     if(stickyNormal){
      if(!stickyNormal.classList.contains('hdt-btn-loading') && stickyNormal.getAttribute('variant-state')==='available') setText(stickyNormal.querySelector('.hdt-btn-atc_text'),count?sticky.dataset.productLabel:sticky.dataset.cartLabel);
      setProperty(stickyNormal,'disabled',busy || !single.valid || !main.variant?.available || !!form.querySelector('button[name="add"]')?.disabled);
     }
     if(stickyBundle){
      setProperty(stickyBundle,'hidden',!count);
      setProperty(stickyBundle,'disabled',button.disabled);
      setAttribute(stickyBundle,'aria-busy',String(busy));
      setText(stickyBundle.querySelector('[data-sticky-bundle-total]'),quote.valid?money.format(total/100):'—');
      setText(stickyBundle.querySelector('[data-sticky-bundle-discount]'),percent?sticky.dataset.savingLabel.replace('[percent]',percent):'');
     }
     const stickyError=sticky.querySelector('[data-sticky-bundle-error]');
     if(stickyError){setProperty(stickyError,'hidden',error.hidden);setText(stickyError,error.textContent);}
    }
    if(quoteChanged && status.classList.contains('is-updated')) status.classList.remove('is-updated');
    if(quoteChanged && animate && !reducedMotion.matches){
     cancelAnimationFrame(statusFrame);statusFrame=requestAnimationFrame(() => {statusFrame=0;if(!disclosureEvents.signal.aborted)status.classList.add('is-updated');});
    }
   };
   const accessoryForControl = control => control.matches('[data-preview-quantity]') ? previewCard : control.closest('[data-bundle-card]');
   listen(host,'input',event => {
    if(!event.target.matches('[data-bundle-quantity],[data-preview-quantity]')) return;
    const card=accessoryForControl(event.target), input=card?.querySelector('[data-bundle-item]');
    if(!input || input.disabled || busy) return;
    const raw=event.target.value, canonical=resolveAccessoryQuantity(raw,quantityRules(input),input.dataset.quantity);
    if(raw !== '' && Number.isSafeInteger(Number(raw)) && Number(raw) === canonical) changeAccessoryQuantity(card,raw);
    else {quantityDrafts.set(input,raw);update();}
   });
   listen(host,'focusout',event => {
    if(!event.target.matches('[data-bundle-quantity],[data-preview-quantity]')) return;
    const card=accessoryForControl(event.target), input=card?.querySelector('[data-bundle-item]');
    if(quantityDrafts.has(input)) changeAccessoryQuantity(card,event.target.value);
   });
   listen(host,'keydown',event => {
    if(event.key === 'Enter' && event.target.matches('[data-bundle-quantity],[data-preview-quantity]')){
     event.preventDefault();changeAccessoryQuantity(accessoryForControl(event.target),event.target.value);
    }
   });
   listen(host,'change',event => {
    if(event.target.matches('[data-bundle-quantity]')) changeAccessoryQuantity(event.target.closest('[data-bundle-card]'),event.target.value);
   });
   inputs.forEach(input => listen(input,'change', () => {
    if(input.checked && quantityDrafts.has(input)) input.checked=false;
    if(!input.checked) quantityDrafts.delete(input);
    const wasSelected=input.closest('.mk-bundle-card').classList.contains('is-selected');
    update(true);
    if(input.checked && !wasSelected){
     const card=input.closest('.mk-bundle-card');
     celebrate(card.querySelector('.mk-select-check'),[{opacity:0,strokeDasharray:28,strokeDashoffset:28},{opacity:1,strokeDasharray:28,strokeDashoffset:0}]);
    }
   }));
   host.querySelectorAll('[data-bundle-variant]').forEach(select => listen(select,'change', () => update(true)));
   listen(host,'mk:studio:cart-context',()=>update());
   const onMainQuantity=event=>{if(event.target.name==='quantity')syncImmediateProductPrice();queueQuote();};
   listen(form,'input',onMainQuantity);
   listen(form,'change',onMainQuantity);
   listen(form,'variant:change',queueQuote);
   const quoteObserver=new MutationObserver(queueQuote);
   quoteObserver.observe(form,{subtree:true,attributes:true,attributeFilter:['value','disabled','variant-state']});
   listen(document,'variant:update',queueQuote);
   listen(document,'quantity-selector:update',queueQuote);
   listen(document,'cart:drawer:render',queueQuote);
   listen(document,'cart:count:update',queueQuote);
   listen(button,'click', async () => {
    if(busy) return;
    // Native events may share a queued frame; validate current values before submit.
    update();
    if(button.disabled) return;
    const main = mainItem(), selected = inputs.filter(input => input.checked && !input.disabled);
    if(!main.variant?.available || !form.reportValidity()) return;
    busy = true; update(); error.hidden = true; button.setAttribute('aria-busy','true'); buttonText.textContent = button.dataset.adding;
    const mainLine = {id:main.variant.id,quantity:main.quantity};
    if(main.data.get('selling_plan')) mainLine.selling_plan = main.data.get('selling_plan');
    const properties = {};
    for(const [key,value] of main.data) if(key.startsWith('properties[') && key.endsWith(']')) properties[key.slice(11,-1)] = value;
    if(Object.keys(properties).length) mainLine.properties = properties;
    const items = [mainLine,...selected.map(input => ({id:Number(input.dataset.variantId),quantity:Number(input.dataset.quantity || 1)}))];
    const root = window.Shopify?.routes?.root || '/';
    try {
     const drawer = document.querySelector('hdt-cart-drawer');
     const sectionId = drawer?.getAttribute('section-id');
     const nativeEvents = await import('@theme/events').catch(() => null);
     if(disclosureEvents.signal.aborted) return;
     const payload = {items};
     if(sectionId && nativeEvents) {payload.sections = [sectionId]; payload.sections_url = location.pathname;}
     const response = await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload),signal:disclosureEvents.signal});
     const result = await response.json();
     if(disclosureEvents.signal.aborted) return;
     if(!response.ok || result.status) throw new Error(result.description || button.dataset.error);
     window.MonsterCommerceMotion?.commit({button,images:[host.querySelector('[data-studio-main-image]'),...selected.map(input=>input.closest('.mk-bundle-card')?.querySelector('img'))]});
     if(nativeEvents && sectionId && result.sections?.[sectionId]) {
      host.dispatchEvent(new nativeEvents.CartUpdateEvent({},sectionId,result,'open_cart_drawer','product-form-component'));
     } else {location.assign(root+'cart'); return;}
    } catch(failure) {
     if(disclosureEvents.signal.aborted) return;
     error.textContent = failure instanceof SyntaxError ? button.dataset.error : failure.message || button.dataset.error; error.hidden = false;
    } finally {
     busy = false;
     if(!disclosureEvents.signal.aborted){button.removeAttribute('aria-busy');buttonText.textContent=originalText;update();}
    }
   });
   update();
  });
 }
 if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
 else initialize();
 document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

(() => {
 function initialize(scope = document) {
  scope.querySelectorAll('[data-payment-trust]').forEach(host => {
   if(host.dataset.paymentReady) return;
   host.dataset.paymentReady = 'true';
   host.classList.add('is-paused');
   new IntersectionObserver(entries => host.classList.toggle('is-paused', !entries[0].isIntersecting), {threshold:.1}).observe(host);
  });
  scope.querySelectorAll('[data-payment-dialog]').forEach(dialog => {
   if(dialog.dataset.paymentReady) return;
   dialog.dataset.paymentReady = 'true';
   dialog.addEventListener('close', () => {
    if(!document.querySelector('[data-payment-dialog][open]')) document.documentElement.removeAttribute('data-mk-payment-lock');
    const cartDialog = dialog.paymentTrigger?.closest('dialog[data-monster-cart]');
    if(dialog.paymentContainer) {
     if(dialog.paymentContainer.isConnected) {
      const next = dialog.paymentNext?.parentElement === dialog.paymentContainer ? dialog.paymentNext : null;
      dialog.paymentContainer.insertBefore(dialog,next);
     } else dialog.remove();
     dialog.paymentContainer = null;
     dialog.paymentNext = null;
    }
    const target = cartDialog && !cartDialog.open ? document.querySelector('button[aria-controls="CartDrawer"],a[aria-controls="CartDrawer"]') : dialog.paymentTrigger;
    if(target?.isConnected) target.focus({preventScroll:true});
   });
   dialog.addEventListener('click', event => {
    if(event.target.closest('[data-payment-close]')) { dialog.close(); return; }
    if(event.target === dialog) {
     const rect = dialog.getBoundingClientRect();
     if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
   });
  });
  scope.querySelectorAll('#CartDrawer').forEach(dialog => {
   if(dialog.dataset.paletteReady) return;
   dialog.dataset.paletteReady = 'true';
   const updatePalette = () => {
    const primary = dialog.querySelector('[data-cart-item-palette]:not([data-cart-item-palette="brand"])');
    dialog.dataset.palette = primary?.dataset.cartItemPalette || (dialog.querySelector('hdt-line-item') ? 'brand' : document.querySelector('[data-monster-product]')?.dataset.palette || 'brand');
    const caption = dialog.querySelector('[data-cart-caption]');
    if (caption) {
     const count = [...dialog.querySelectorAll('input[name="updates[]"]')].reduce((total, input) => total + Math.max(0, Number(input.value) || 0), 0);
     const text = caption.dataset.countLabel.replace('[count]', String(count));
     if (caption.textContent !== text) caption.textContent = text;
    }
   };
   new MutationObserver(updatePalette).observe(dialog,{childList:true,subtree:true,attributes:true,attributeFilter:['value']});
   updatePalette();
  });
 }
 document.addEventListener('click', async event => {
  const trigger = event.target.closest('[data-payment-open]');
  if(!trigger) return;
  const id = trigger.dataset.paymentOpen;
  const dialog = id ? document.getElementById(id) : document.querySelector('[data-payment-dialog]');
  if(!dialog || dialog.open) return;
  initialize(dialog.parentElement);
  const palette = trigger.closest('[data-monster-cart]')?.dataset.palette || document.querySelector('[data-monster-product]')?.dataset.palette || document.querySelector('[data-monster-cart]')?.dataset.palette || 'brand';
  event.preventDefault();
  for(const nativeDialog of document.querySelectorAll('dialog[open]:not([data-payment-dialog])')) {
   if(typeof nativeDialog.parentElement?.close === 'function') await nativeDialog.parentElement.close();
   else nativeDialog.close();
  }
  if(trigger.closest('dialog[data-monster-cart]')) {
   dialog.paymentContainer = dialog.parentElement;
   dialog.paymentNext = dialog.nextSibling;
   document.body.append(dialog);
  }
  dialog.dataset.palette = palette;
  dialog.paymentTrigger = trigger;
  dialog.showModal();
  document.documentElement.setAttribute('data-mk-payment-lock','');
 });
 if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
 else initialize();
 document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

(() => {
 function prepareGallery(host) {
  if (host.dataset.galleryReady || !host.closest('[data-monster-product]')) return;
  host.dataset.galleryReady = 'true';
  const hoverGallery = window.matchMedia('(min-width: 1150px) and (hover: hover) and (pointer: fine)');
  const reduceGalleryMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const thumbViewport = host.querySelector('.hdt-product-media__thumb .hdt-slider__viewport');
  const thumbButtons = [...host.querySelectorAll('.mk-thumb-arrow')];
  const desktopThumbs = window.matchMedia('(min-width: 1150px)');
  let firstHiddenThumb = -1;
  let navigationFrame = 0;
  const syncThumbNavigation = () => {
   if (!thumbViewport || thumbButtons.length !== 2) return;
   if (!desktopThumbs.matches) {
    const bounds = thumbViewport.getBoundingClientRect();
    const items = [...host.querySelectorAll('.hdt-thumbnail__media:not([hidden])')];
    thumbButtons[0].disabled = !items.length || items[0].getBoundingClientRect().left >= bounds.left - 2;
    thumbButtons[1].disabled = !items.length || items[items.length - 1].getBoundingClientRect().right <= bounds.right + 2;
    thumbButtons[0].setAttribute('aria-label', 'Scroll to previous images');
    thumbButtons[1].setAttribute('aria-label', 'Scroll to next images');
    return;
   }
   thumbButtons[0].disabled = thumbViewport.scrollTop < 2;
   const viewportRect = thumbViewport.getBoundingClientRect();
   const edge = desktopThumbs.matches ? viewportRect.bottom : viewportRect.right - 40;
   const thumbs = [...host.querySelectorAll('.hdt-thumbnail__media:not([hidden])')];
   const remaining = thumbs.filter(item => {const rect=item.getBoundingClientRect();return desktopThumbs.matches ? rect.top >= edge - 1 : rect.right > edge + 1;});
   firstHiddenThumb = remaining.length ? thumbs.indexOf(remaining[0]) : -1;
   const more = thumbButtons[1];
   const railEndVisible = !desktopThumbs.matches && (!thumbs.length || thumbs[thumbs.length - 1].getBoundingClientRect().right <= viewportRect.right + 1);
   more.disabled = railEndVisible || remaining.length === 0;
   const counter = more.querySelector('[data-gallery-remaining]');
   if (counter && counter.textContent !== `+${remaining.length}`) counter.textContent = `+${remaining.length}`;
   more.setAttribute('aria-label', desktopThumbs.matches ? (more.dataset.moreLabel || '').replace('[count]', String(remaining.length)) : 'Scroll to next images');
  };
  thumbButtons.forEach((button, index) => button.addEventListener('click', () => {
   if (!desktopThumbs.matches) {
    syncThumbNavigation();
    if (button.disabled || !thumbViewport) return;
    const slider = thumbViewport.closest('hdt-slider-thumb');
    const items = [...host.querySelectorAll('.hdt-thumbnail__media:not([hidden])')];
    const bounds = thumbViewport.getBoundingClientRect();
    const step = Math.max(80, bounds.width * .65);
    let target = index ? items.findIndex(item => item.getBoundingClientRect().left >= bounds.left + step - 1) : -1;
    if (!index) {
     for (let i = items.length - 1; i >= 0; i--) {
      if (items[i].getBoundingClientRect().left <= bounds.left - step + 1) { target = i; break; }
     }
    }
    if (target < 0) target = index ? items.length - 1 : 0;
    if (slider?.isActive && typeof slider.goToIndex === 'function') {
     slider.goToIndex(target, reduceGalleryMotion.matches);
    } else {
     thumbViewport.scrollBy({left: (index ? 1 : -1) * step, behavior: reduceGalleryMotion.matches ? 'auto' : 'smooth'});
    }
    scheduleThumbNavigation();
    return;
   }
   if (index && firstHiddenThumb >= 0) {
    if (host.dataset.mkExplorerReady) host.dispatchEvent(new CustomEvent('mk:media:open', {detail: {position: firstHiddenThumb}}));
    else host.dispatchEvent(new CustomEvent('lightbox:psw:open', {bubbles: true, detail: {index: firstHiddenThumb}}));
   } else {
    thumbViewport.scrollBy({top: -thumbViewport.clientHeight * .8, behavior: reduceGalleryMotion.matches ? 'auto' : 'smooth'});
   }
  }));
  const scheduleThumbNavigation = () => {
   if (navigationFrame) return;
   navigationFrame = requestAnimationFrame(() => {
    navigationFrame = 0;
    syncThumbNavigation();
   });
  };
  thumbViewport?.addEventListener('scroll', scheduleThumbNavigation, {passive: true});
  const thumbTrack = thumbViewport?.querySelector('.hdt-slider__container');
  if (thumbTrack) new MutationObserver(scheduleThumbNavigation).observe(thumbTrack, {attributes: true, attributeFilter: ['style']});
  if (thumbViewport) new ResizeObserver(scheduleThumbNavigation).observe(thumbViewport);
  desktopThumbs.addEventListener('change', scheduleThumbNavigation);
  let selectedThumb = null;
  const resetGalleryZoom = [];
  host.querySelectorAll('.hdt-product-media__main [data-media-type="image"]').forEach(item => {
   const image = item.querySelector('img');
   if (!image) return;
   let zoomFrame = 0;
   let bounds = null;
   let targetX = 50, targetY = 50, currentX = 50, currentY = 50, previousTime = 0;
   const renderPointer = time => {
    zoomFrame = 0;
    if (!item.classList.contains('mk-reference-zoom') || !item.isConnected) return;
    const elapsed = previousTime ? Math.min(time - previousTime, 64) : 16;
    const blend = reduceGalleryMotion.matches ? 1 : 1 - Math.exp(-elapsed / 85);
    previousTime = time;
    currentX += (targetX - currentX) * blend;
    currentY += (targetY - currentY) * blend;
    if (Math.abs(targetX - currentX) < .02 && Math.abs(targetY - currentY) < .02) {
     currentX = targetX;
     currentY = targetY;
     previousTime = 0;
    } else {
     zoomFrame = requestAnimationFrame(renderPointer);
    }
    image.style.setProperty('--mk-gallery-zoom-origin', `${currentX.toFixed(3)}% ${currentY.toFixed(3)}%`);
   };
   const followPointer = event => {
    if (!hoverGallery.matches || event.pointerType === 'touch' || event.buttons ||
     document.querySelector('.pswp--open') ||
     (item.classList.contains('hdt-slider__slide') && !item.classList.contains('is-selected'))) return;
    bounds ||= item.getBoundingClientRect();
    targetX = Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100));
    targetY = Math.max(0, Math.min(100, (event.clientY - bounds.top) / bounds.height * 100));
    if (!item.classList.contains('mk-reference-zoom')) {
     currentX = targetX;
     currentY = targetY;
     image.style.setProperty('--mk-gallery-zoom-origin', `${currentX}% ${currentY}%`);
     item.classList.add('mk-reference-zoom');
    }
    if (!zoomFrame) zoomFrame = requestAnimationFrame(renderPointer);
   };
   const resetZoom = () => {
    cancelAnimationFrame(zoomFrame);
    zoomFrame = 0;
    previousTime = 0;
    bounds = null;
    item.classList.remove('mk-reference-zoom');
   };
   resetGalleryZoom.push(resetZoom);
   item.addEventListener('pointerenter', followPointer);
   item.addEventListener('pointermove', followPointer, {passive: true});
   item.addEventListener('pointerleave', resetZoom);
   item.addEventListener('pointerdown', event => { if (event.button === 0) resetZoom(); });
   item.addEventListener('pointercancel', resetZoom);
   item.addEventListener('click', resetZoom);
   hoverGallery.addEventListener('change', resetZoom);
   const syncMotion = () => {
    resetZoom();
    image.style.setProperty('--mk-gallery-zoom-duration', reduceGalleryMotion.matches ? '0ms' : '650ms');
   };
   reduceGalleryMotion.addEventListener('change', syncMotion);
   syncMotion();
   const invalidateBounds = () => { bounds = null; };
   window.addEventListener('scroll', invalidateBounds, {passive: true});
   window.addEventListener('resize', invalidateBounds, {passive: true});
  });
  window.addEventListener('blur', () => resetGalleryZoom.forEach(reset => reset()));
  host.querySelector('.hdt-product-media__main hdt-slider')?.addEventListener('select:slide', () => resetGalleryZoom.forEach(reset => reset()));
  host.addEventListener('lightbox:psw:open', () => {
   resetGalleryZoom.forEach(reset => reset());
   if (host.dataset.mkExplorerReady) return;
   const lightbox = host.lightBox;
   if (!lightbox?.options) return;
   document.documentElement.style.setProperty('--mk-gallery-page-width', `${document.documentElement.clientWidth}px`);
   const thumbRail = host.querySelector('.hdt-product-media__thumb');
   if (desktopThumbs.matches && thumbRail) host.style.setProperty('--mk-gallery-locked-thumb-size', `${thumbRail.getBoundingClientRect().width}px`);
   if (!host.dataset.galleryLightboxReady) {
    host.dataset.galleryLightboxReady = 'true';
    lightbox.on('destroy', () => {
     document.documentElement.style.removeProperty('--mk-gallery-page-width');
     host.style.removeProperty('--mk-gallery-locked-thumb-size');
    });
   }
   lightbox.options.bgOpacity = 1;
   lightbox.options.zoom = false;
   lightbox.options.initialZoomLevel = 'fit';
   lightbox.options.secondaryZoomLevel = levels => levels.fit * 1.4;
   lightbox.options.maxZoomLevel = levels => levels.fit * 1.6;
   lightbox.options.showHideAnimationType = 'fade';
   lightbox.options.easing = 'cubic-bezier(.22,.61,.36,1)';
   lightbox.options.paddingFn = viewport => ({top: 80, bottom: viewport.x < 768 ? 98 : 116, left: viewport.x < 768 ? 14 : 80, right: viewport.x < 768 ? 14 : 80});
   const duration = reduceGalleryMotion.matches ? 0 : 340;
   lightbox.options.showAnimationDuration = duration;
   lightbox.options.hideAnimationDuration = duration;
   lightbox.options.zoomAnimationDuration = duration;
  }, true);
  const update = () => {
   host.querySelectorAll('.hdt-product-media__main [data-media-type="image"]').forEach(item => {
    item.setAttribute('role', 'button');
    item.tabIndex = item.classList.contains('hdt-slider__slide') && !item.classList.contains('is-selected') ? -1 : 0;
    item.dataset.galleryOpen = 'true';
    item.setAttribute('aria-label', host.dataset.galleryOpenLabel.replace('[title]', item.querySelector('img')?.alt || ''));
   });
   host.querySelectorAll('.hdt-thumbnail__media').forEach((item, index) => {
    item.setAttribute('role', 'button');
    item.tabIndex = 0;
    item.dataset.galleryThumb = 'true';
    item.setAttribute('aria-label', host.dataset.galleryThumbLabel.replace('[number]', String(index + 1)));
    item.setAttribute('aria-pressed', String(item.classList.contains('is-thumb-selected')));
    if (desktopThumbs.matches && item.classList.contains('is-thumb-selected') && selectedThumb !== item && thumbViewport) {
     selectedThumb = item;
     const frame = thumbViewport.getBoundingClientRect();
     const bounds = item.getBoundingClientRect();
     const shift = bounds.top < frame.top ? bounds.top - frame.top : bounds.bottom > frame.bottom ? bounds.bottom - frame.bottom : 0;
     if (shift) thumbViewport.scrollBy({top: shift, behavior: reduceGalleryMotion.matches ? 'auto' : 'smooth'});
    }
   });
   scheduleThumbNavigation();
  };
  update();
  let updateFrame = 0;
  new MutationObserver(records => {
   const selectionChanged = records.some(record => record.type === 'childList' || record.attributeName === 'hidden' ||
    ['is-selected', 'is-thumb-selected'].some(name => (record.oldValue || '').split(/\s+/).includes(name) !== record.target.classList.contains(name)));
   if (!selectionChanged || updateFrame) return;
   updateFrame = requestAnimationFrame(() => {
    updateFrame = 0;
    update();
   });
  }).observe(host, {childList: true, subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['class', 'hidden']});
 }
 function prepareLightbox(host) {
  if (!host || !document.querySelector('[data-monster-product]')) return;
  host.dataset.palette = document.querySelector('[data-monster-product]').dataset.palette;
  host.querySelectorAll('.pswp__thumbnail').forEach((item, index) => {
   item.setAttribute('role', 'button');
   item.tabIndex = 0;
   const gallery = document.querySelector('hdt-product-media[data-gallery-thumb-label]');
   if (gallery) item.setAttribute('aria-label', gallery.dataset.galleryThumbLabel.replace('[number]', String(index + 1)));
   item.setAttribute('aria-pressed', String(item.classList.contains('pswp__thumbnail--active')));
  });
 }
 function initialize(scope = document) {
  if (scope.matches?.('hdt-product-media')) prepareGallery(scope);
  scope.querySelectorAll?.('hdt-product-media').forEach(prepareGallery);
  const lightbox = scope.matches?.('.pswp') ? scope : scope.closest?.('.pswp');
  if (lightbox) prepareLightbox(lightbox);
  scope.querySelectorAll?.('.pswp').forEach(prepareLightbox);
 }
 document.addEventListener('keydown', event => {
  const item = event.target.closest('[data-gallery-open], [data-gallery-thumb], .pswp__thumbnail');
  if (!item || event.altKey || event.ctrlKey || event.metaKey) return;
  if (event.key === 'Enter' || event.key === ' ') {
   event.preventDefault();
   event.stopPropagation();
   item.click();
   return;
  }
  if (!item.matches('[data-gallery-thumb], .pswp__thumbnail')) return;
  const selector = item.matches('.pswp__thumbnail') ? '.pswp__thumbnail' : '[data-gallery-thumb]';
  const items = [...item.parentElement.parentElement.querySelectorAll(selector)].filter(element => !element.hidden);
  const index = items.indexOf(item);
  let target;
  if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = items[(index + 1) % items.length];
  if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = items[(index - 1 + items.length) % items.length];
  if (event.key === 'Home') target = items[0];
  if (event.key === 'End') target = items.at(-1);
  if (target) { event.preventDefault(); event.stopPropagation(); target.focus({preventScroll: true}); target.click(); }
 }, true);
 const observe = () => {
  initialize();
  new MutationObserver(records => {
   for (const record of records) {
    if (record.type === 'attributes' && record.target.matches('.pswp__thumbnail')) prepareLightbox(record.target.closest('.pswp'));
    for (const node of record.addedNodes) if (node.nodeType === 1) initialize(node);
   }
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
 else observe();
 document.addEventListener('shopify:section:load', event => initialize(event.target));
})();


// Keep the gallery below the actual sticky header as its size changes.
(() => {
 const initialize = () => {
  const header = document.querySelector('header[id*="__header"]');
  if (!header || !document.querySelector('[data-monster-product]')) return;
  if (header.dataset.mkGalleryOffsetReady) return;
  header.dataset.mkGalleryOffsetReady = 'true';
  let previous = '', height = header.offsetHeight, frame = 0;
  const update = () => {
   frame = 0;
   const hidden = header.classList.contains('shopify-section-header-hidden') && !header.classList.contains('menu-open') && !header.matches(':focus-within');
   const next = ((hidden ? 0 : Math.round(height)) + 16) + 'px';
   if (next !== previous) { previous = next; document.documentElement.style.setProperty('--mk-gallery-top', next); }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  new ResizeObserver(entries => { const box=entries[0]?.borderBoxSize; height=box?(box[0]||box).blockSize:header.offsetHeight; schedule(); }).observe(header);
  new MutationObserver(schedule).observe(header, {attributes:true,attributeFilter:['class']});
  header.addEventListener('focusin', schedule);
  header.addEventListener('focusout', schedule);
  update();
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
 document.addEventListener('shopify:section:load', initialize);
})();

// Keep animated outlines in physical pixels, including after responsive resizing.
(() => {
 const update = button => {
  const svg=button.querySelector('.mk-atc-dashes'), rect=svg?.querySelector('rect');
  if(!rect) return;
  const {width,height}=button.getBoundingClientRect();
  if(width<4||height<4) return;
  svg.setAttribute('viewBox', '0 0 '+width+' '+height);
  rect.setAttribute('x','1'); rect.setAttribute('y','1');
  rect.setAttribute('width',String(width-2)); rect.setAttribute('height',String(height-2));
  const radius=Math.max(0,parseFloat(getComputedStyle(button).borderTopLeftRadius)-1)||0;
  rect.setAttribute('rx',String(radius)); rect.setAttribute('ry',String(radius));
  rect.removeAttribute('pathLength');
 };
 const observer=new ResizeObserver(entries=>entries.forEach(entry=>update(entry.target)));
 const initialize=(scope=document)=>scope.querySelectorAll('.mk-product-atc,.mk-bundle-add').forEach(button=>{
  if(button.dataset.outlineReady) return;
  button.dataset.outlineReady='true'; observer.observe(button); update(button);
 });
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true}); else initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();

(() => {
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const observed=new WeakSet();
 const fit=target=>{
  const content=target.querySelector('[data-setup-fit-content]');
  if(!content) return;
  const header=document.querySelector('header[id*="__header"]');
  const bar=[...document.querySelectorAll('.mk-purchase-bar')].find(item=>item.getAttribute('form')===target.dataset.formId);
  const available=Math.max(160,(visualViewport?.height || innerHeight)-(header?.offsetHeight || 0)-(bar?.offsetHeight || 0)-24);
  let scale=Number(target.style.getPropertyValue('--mk-setup-scale')) || 1/1.2;
  const height=content.getBoundingClientRect().height;
  const padding=parseFloat(getComputedStyle(target).paddingTop)+parseFloat(getComputedStyle(target).paddingBottom);
  const next=Math.max(.5,Math.min(1/1.2,(available-padding)/Math.max(1,height/scale)));
  if(Math.abs(next-scale)>.002)target.style.setProperty('--mk-setup-scale',String(next));
  return {top:(header?.offsetHeight || 0)+8};
 };
 const initialize=(scope=document)=>{
  scope.querySelectorAll('[data-product-jump]').forEach(link=>{
   if(link.dataset.jumpReady)return;link.dataset.jumpReady='true';
   const target=document.getElementById(link.hash.slice(1));
   if(!target){link.hidden=true;return;}
   link.addEventListener('click',event=>{
    event.preventDefault();
    const heading=target.querySelector('h1') || target;
    const header=document.querySelector('header[id*="__header"]');
    const offset=(header?.offsetHeight || 0)+16;
    window.scrollTo({top:Math.max(0,scrollY+target.getBoundingClientRect().top-offset),behavior:reduced.matches?'instant':'smooth'});
    if(!heading.hasAttribute('tabindex'))heading.setAttribute('tabindex','-1');
    heading.focus({preventScroll:true});
   });
  });
  scope.querySelectorAll('[data-bundle-jump]').forEach(link=>{
  if(link.dataset.jumpReady) return;
  link.dataset.jumpReady='true';
  const target=document.getElementById(link.hash.slice(1));
  if(!target){link.hidden=true;return;}
  if(!observed.has(target)){
   observed.add(target);
   let frame=0;
   const schedule=()=>{if(target.classList.contains('is-setup-fit')&&!frame)frame=requestAnimationFrame(()=>{frame=0;fit(target);});};
   const observer=new ResizeObserver(schedule);
   observer.observe(target.querySelector('[data-setup-fit-content]') || target);
   addEventListener('resize',schedule,{passive:true});
   visualViewport?.addEventListener('resize',schedule,{passive:true});
  }
  link.addEventListener('click',event=>{
   event.preventDefault();
   const disclosure=target.querySelector('[data-setup-disclosure]');
   if(disclosure){
    target.dispatchEvent(new CustomEvent('mk:setup:open'));
    requestAnimationFrame(()=>{
     const header=document.querySelector('header[id*="__header"]');
     const top=(header?.offsetHeight || 0)+12;
     window.scrollTo({top:Math.max(0,scrollY+target.getBoundingClientRect().top-top),behavior:reduced.matches?'instant':'smooth'});
     disclosure.querySelector('summary')?.focus({preventScroll:true});
    });
    return;
   }
   target.classList.add('is-setup-fit');
   fit(target);
   requestAnimationFrame(()=>{
    const {top}=fit(target) || {top:8};
    window.scrollTo({top:Math.max(0,scrollY+target.getBoundingClientRect().top-top),behavior:reduced.matches?'instant':'smooth'});
    target.querySelector('[data-bundle-heading]')?.focus({preventScroll:true});
   });
  });
 });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});else initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
(() => {
 const hover=matchMedia('(hover:hover)');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const hideTimers=new WeakMap();
 let active=null,leaveTimer=0,frame=0;
 const close=()=>{
  clearTimeout(leaveTimer);
  if(!active)return;
  const help=active,panel=help.querySelector('.mk-fact-tooltip');
  active=null;cancelAnimationFrame(frame);frame=0;
  help.querySelector('button').setAttribute('aria-expanded','false');
  delete help.dataset.pinned;
  panel.dataset.open='false';panel.setAttribute('aria-hidden','true');panel.inert=true;
  clearTimeout(hideTimers.get(panel));
  if(reduced.matches)panel.hidden=true;
  else hideTimers.set(panel,setTimeout(()=>{panel.hidden=true;hideTimers.delete(panel);},220));
 };
 const place=()=>{
  frame=0;
  if(!active)return;
  const panel=active.querySelector('.mk-fact-tooltip');
  const rect=active.querySelector('button').getBoundingClientRect();
  const width=panel.offsetWidth,height=panel.offsetHeight,viewport=document.documentElement.clientWidth;
  const left=Math.max(12,Math.min(rect.left,viewport-width-12))+'px';
  const below=rect.bottom+8;
  const top=(below+height<innerHeight-12?below:Math.max(12,rect.top-height-8))+'px';
  if(panel.style.left!==left)panel.style.left=left;
  if(panel.style.top!==top)panel.style.top=top;
  if(panel.dataset.open!=='true')panel.dataset.open='true';
 };
 const schedulePlace=()=>{if(active&&!frame)frame=requestAnimationFrame(place);};
 const open=help=>{
  clearTimeout(leaveTimer);
  if(active===help)return;
  if(active)close();
  active=help;
  const panel=help.querySelector('.mk-fact-tooltip');
  clearTimeout(hideTimers.get(panel));hideTimers.delete(panel);
  panel.hidden=false;panel.inert=false;panel.setAttribute('aria-hidden','false');
  help.querySelector('button').setAttribute('aria-expanded','true');
  schedulePlace();
 };
 const initialize=(scope=document)=>scope.querySelectorAll('[data-fact-help]').forEach(help=>{
  if(help.dataset.ready)return;
  help.dataset.ready='true';
  const button=help.querySelector('button'),panel=help.querySelector('.mk-fact-tooltip');
  panel.dataset.open='false';panel.setAttribute('aria-hidden','true');panel.inert=true;
  help.addEventListener('pointerenter',()=>{if(hover.matches)open(help);});
  help.addEventListener('pointerleave',event=>{
   if(help.contains(event.relatedTarget))return;
   if(active===help&&help.dataset.pinned!=='true')leaveTimer=setTimeout(close,220);
  });
  panel.addEventListener('pointerenter',()=>clearTimeout(leaveTimer));
  button.addEventListener('focus',()=>{if(button.matches(':focus-visible'))open(help);});
  help.addEventListener('focusout',event=>{if(active===help&&!help.contains(event.relatedTarget))close();});
  button.addEventListener('click',()=>{
   if(active===help&&help.dataset.pinned==='true')close();
   else{open(help);help.dataset.pinned='true';}
  });
 });
 document.addEventListener('click',event=>{if(active&&!active.contains(event.target))close();});
 document.addEventListener('keydown',event=>{if(event.key==='Escape')close();});
 addEventListener('resize',schedulePlace,{passive:true});
 addEventListener('scroll',schedulePlace,{passive:true,capture:true});
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});else initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();


